const el = {
  common: {
    myProjects: 'Τα έργα μου',
    loading: 'Φόρτωση...',
    saving: 'Αποθήκευση...',
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    delete: 'Διαγραφή',
    deleteTip: 'Διαγραφή',
    editTip: 'Επεξεργασία',
    edit: 'Επεξεργασία',
    readOnly: '👁 Μόνο ανάγνωση',
    exportWord: '⬇ Εξαγωγή σε Word',
    exportExcel: '⬇ Εξαγωγή σε Excel',
    createAI: '✦ Δημιουργία με AI',
    regenerateAI: '✦ Αναδημιουργία με AI',
    generating: '⏳ Δημιουργία...',
    addItem: '+ Προσθήκη',
    back: 'Επιστροφή',
    continue: 'Συνέχεια',
    aiConfirmSubtitle: 'Αυτόματη ανάλυση από τη σύμβαση',
    dateLocale: 'el-GR',
    wordFooter: (name: string, date: string) => `Δημιουργήθηκε από: ${name} | ${date}`,
  },

  projectCharter: {
    pageTitle: 'Project Charter',
    generatingTitle: 'Δημιουργία Project Charter...',
    analyzingContract: 'Ανάλυση σύμβασης',
    emptyState: 'Δεν υπάρχουν δεδομένα ακόμα. Χρησιμοποίησε το κουμπί "✦ Δημιουργία με AI" ή ανέβασε έγγραφο σύμβασης.',
    sectionScope: 'Αντικείμενο Έργου',
    sectionObjectives: 'Στόχοι',
    sectionDeliverables: 'Παραδοτέα',
    sectionStakeholders: 'Εμπλεκόμενοι',
    sectionBudget: 'Προϋπολογισμός',
    sectionDuration: 'Διάρκεια',
    aiConfirmTitle: 'AI Δημιουργία Project Charter',
    aiConfirmWarning: 'Το AI θα δημιουργήσει αυτόματα το Project Charter από τη σύμβαση. Τυχόν υπάρχοντα δεδομένα θα αντικατασταθούν.',
    errorGenerate: 'Σφάλμα κατά τη δημιουργία. Δοκίμασε ξανά.',
  },

  kickoff: {
    subtitle: 'Εναρκτήρια παρουσίαση έργου — bullet points για PowerPoint',
    generatingTitle: 'Προετοιμασία Kickoff Presentation...',
    analyzingContract: 'Ανάλυση σύμβασης και ρίσκων',
    emptyTitle: 'Δεν υπάρχει Kickoff Presentation ακόμα',
    emptyDesc: 'Πάτα "✦ Δημιουργία με AI" για να δημιουργήσεις αυτόματα την εναρκτήρια παρουσίαση βάσει της σύμβασης',
    addBullet: '+ Προσθήκη bullet',
    noData: 'Δεν υπάρχουν δεδομένα',
    aiConfirmTitle: 'AI Δημιουργία Kickoff Presentation',
    aiConfirmWarning: 'Το AI θα δημιουργήσει αυτόματα την Kickoff Presentation από τη σύμβαση. Τυχόν υπάρχοντα δεδομένα θα αντικατασταθούν.',
    sections: {
      project_purpose: 'Σκοπός Έργου',
      project_scope: 'Αντικείμενο Έργου',
      technical_solution: 'Περιγραφή Τεχνικής Λύσης',
      key_risks: 'Κύρια Ρίσκα',
      prerequisites: 'Βασικές Προαπαιτήσεις',
      next_steps: 'Επόμενα Βήματα',
    } as Record<string, string>,
  },

  schedule: {
    months: ['Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάιος', 'Ιούνιος', 'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'] as string[],
    days: ['Κυ', 'Δε', 'Τρ', 'Τε', 'Πε', 'Πα', 'Σα'] as string[],
    statusLabels: {
      not_started: 'Δεν ξεκίνησε',
      in_progress: 'Σε εξέλιξη',
      completed: 'Ολοκληρώθηκε',
      delayed: 'Καθυστέρηση',
    } as Record<string, string>,
    summaryPhases: 'Φάσεις',
    summaryDays: 'Ημέρες',
    summaryStart: 'Έναρξη',
    summaryEnd: 'Λήξη',
    legendCompleted: 'Ολοκληρώθηκε',
    legendToday: 'Σήμερα',
    legendDependency: 'Εξάρτηση',
    checkCriticalOnly: 'Κρίσιμη Διαδρομή',
    btnToday: 'Σήμερα',
    btnNewPhase: '+ Νέα Φάση',
    btnNewActivity: '+ Νέα Activity',
    defaultPhaseTitle: 'Αδιάθετα',
    emptyState: 'Δεν υπάρχουν δεδομένα schedule ακόμα.',
    hintInline: '💡 Κάνε κλικ στις ημέρες για inline επεξεργασία',
    hintDrag: 'Σύρε για να αλλάξεις σειρά',
    hintDoubleClick: 'Διπλό κλικ για μετονομασία',
    aiConfirmTitle: 'AI Δημιουργία Schedule',
    aiConfirmWarning: 'Το AI θα δημιουργήσει αυτόματα το Schedule από τη σύμβαση και το Project Charter. Τυχόν υπάρχον πρόγραμμα θα αντικατασταθεί.',
    errorGenerate: 'Σφάλμα κατά τη δημιουργία schedule. Δοκίμασε ξανά.',
    phaseModalTitle: 'Νέα Φάση',
    phaseNameLabel: 'Όνομα Φάσης *',
    phaseNamePlaceholder: 'π.χ. Φάση 3: Δοκιμές',
    phaseDescLabel: 'Περιγραφή Φάσης',
    phaseColorLabel: 'Χρώμα',
    phasePositionLabel: 'Θέση στο Schedule',
    phasePositionStart: '↑ Στην αρχή (πριν από όλες)',
    phasePositionAfter: (title: string) => `Μετά από: ${title}`,
    phasePositionEnd: '↓ Στο τέλος (μετά από όλες)',
    hintDragBars: '💡 Σύρε τις μπάρες για να αλλάξεις ημερομηνία',
    activityModalEditTitle: 'Επεξεργασία',
    activityModalNewTitle: 'Νέα Activity / Milestone',
    fieldType: 'Τύπος',
    fieldWorkPackage: 'Work Package',
    fieldWorkPackageReadonly: '— Ορίζεται από το Scope —',
    fieldPhase: 'Φάση',
    fieldPhasePlaceholder: '-- Επέλεξε φάση --',
    fieldTitle: 'Τίτλος *',
    fieldDescription: 'Περιγραφή',
    fieldStartDate: 'Ημερομηνία Έναρξης',
    fieldEndDate: 'Ημερομηνία Ολοκλήρωσης',
    fieldDuration: 'Διάρκεια (ημέρες)',
    fieldDeps: 'Εξαρτήσεις',
    fieldDepsEmpty: 'Δεν υπάρχουν άλλα activities ακόμα.',
    fieldAssign: 'Ανάθεση σε',
    fieldAssignEmpty: 'Δεν υπάρχουν εμπλεκόμενοι στο Stakeholders ακόμα.',
    fieldStatus: 'Κατάσταση',
    fieldProgress: '% Εκτέλεσης',
    fieldProgressHelper: '— ενημερώνεται από καταχωρήσεις AC',
    detailDescription: 'Περιγραφή',
    detailDeps: 'Εξαρτήσεις',
    detailAssign: 'Ανάθεση',
    detailAC: 'Πραγματικές Ανθρωποημέρες (AC)',
    detailACTotal: (n: number) => `Σύνολο: ${n} MD`,
    detailProgressCurrent: 'Τρέχον % ολοκλήρωσης:',
    timesheetTeamPlaceholder: '— Ομάδα * —',
    timesheetNotePlaceholder: 'Σημείωση (προαιρετικό)',
    timesheetAddBtn: '+ Καταχώρηση',
    timesheetProgressError: (pct: number) => `Τρέχον % ολοκλήρωσης: **${pct}%** — το νέο % δεν μπορεί να είναι μικρότερο.`,
    validationTeam: 'Επέλεξε ομάδα.',
    validationProgress: 'Συμπλήρωσε % ολοκλήρωσης.',
    validationProgressRange: 'Το % πρέπει να είναι 0–100.',
    excelHeaders: ['WBS', 'Τίτλος', 'Τύπος', 'Έναρξη (ημέρα)', 'Διάρκεια (ημέρες)', 'Critical', 'Κατάσταση', 'Ανατεθειμένοι'] as string[],
    excelYes: 'Ναι',
    excelNo: 'Όχι',
    excelExporting: '⏳ Εξαγωγή...',
    excelBtnLabel: '⬇ Excel',
    excelTitlePrefix: 'Χρονοδιάγραμμα Έργου (Gantt Chart)',
    excelSubtitle: (start: string, days: number, weeks: number, phasesN: number, activitiesN: number, milestonesN: number) =>
      `Ημερομηνία έναρξης: ${start} · Συνολική διάρκεια: ${days} ημέρες (~${weeks} εβδ.) · ${phasesN} φάσεις · ${activitiesN} δραστηριότητες · ${milestonesN} ορόσημα`,
    excelMonthLabel: (n: number) => `Μήνας ${n}`,
    excelColNum: '#',
    excelColTask: 'Εργασία / Παραδοτέο',
    excelColOwner: 'Υπεύθυνος',
    excelColType: 'Τύπος',
    excelColStart: 'Έναρξη\n(Ημ/νία)',
    excelColDuration: 'Διάρκεια\n(ημέρες)',
    excelColEnd: 'Λήξη\n(Ημ/νία)',
    excelColDep: 'Εξάρτηση / Σχόλιο',
    excelTypeActivity: 'Εργασία',
    excelTypeMilestone: 'Milestone',
    excelTypeClientDep: 'Προαπαιτούμενο',
    excelDepAfter: 'Μετά:',
    excelNoOwner: '—',
    excelLegendTitle: 'Υπόμνημα:',
    excelLegendActivity: 'Δραστηριότητα',
    excelLegendCompleted: 'Ολοκληρωμένη',
    excelLegendClientDep: 'Εξάρτηση Πελάτη',
    excelLegendCritical: 'Κρίσιμη Διαδρομή / Καθυστέρηση',
    excelLegendMilestone: 'Milestone / Ορόσημο',
    excelFootnote: 'Το χρονοδιάγραμμα δημιουργήθηκε αυτόματα από τα δεδομένα του eazyproject κατά τη στιγμή της εξαγωγής. Οι εβδομαδιαίες στήλες ξεκινούν από την ημερομηνία έναρξης του έργου.',
    listHeaders: ['WBS', 'Τίτλος', 'Τύπος', 'Έναρξη', 'Διάρκεια', 'Κατάσταση', 'Ανατεθειμένοι'] as string[],
    daysAbbr: 'ημ.',
    labelDays: 'ημέρες',
    labelStartDay: 'Ημέρα Έναρξης',
    labelEndDay: 'Ημέρα Λήξης',
    labelDuration: 'Διάρκεια',
    aiScheduleTitle: 'Ανάλυση Project Charter & Specs και αυτόματη δημιουργία schedule',
  },

  workingCalendar: {
    dropdownTitle: 'ΗΜΕΡΟΛΟΓΙΟ ΕΡΓΟΥ',
    dropdownEdit: 'Επεξεργασία ημερολογίου →',
    kpiWorkingDays: (wd: number, cd: number) => `${wd} Εργάσιμες · ${cd} ημερολογιακές`,
    toastSwitched: (name: string, date: string) => `Ημερολόγιο έργου: ${name} · λήξη ${date}`,
    toastSaved: 'Αποθηκεύτηκε το working time',
    toastSavedRescheduled: (date: string) => `Αποθηκεύτηκε. Επαναπρογραμματισμός · νέα λήξη ${date}`,
    legendNonWorking: 'Μη εργάσιμη',
    legendHoliday: 'Αργία',
    legendException: 'Εξαίρεση',
    calendarDaysSuffix: 'ημερολογιακές',

    baseStandard: 'Standard',
    base24h: '24 Ώρες',
    baseNightShift: 'Night Shift',
    tagBase: 'Βάση',
    tagProject: 'Έργου',
    isProjectCalendar: 'Ημερολόγιο έργου',
    noWorkingDays: 'Χωρίς εργάσιμες ημέρες',

    modalTitle: 'Working time',
    modalSubtitle: (project: string, cal: string) => `${project} · Ημερολόγιο έργου: ${cal}`,
    calendarsTitle: 'Ημερολόγια',
    newCalendar: '+ Νέο ημερολόγιο',
    newProjectNote: 'Νέο έργο: ξεκινά με Standard και τις αργίες της χώρας του έργου.',
    setAsProject: 'Ορισμός ως ημερολόγιο έργου',
    delete: 'Διαγραφή',
    tabCalendar: 'Ημερολόγιο',
    tabWeek: 'Εβδομάδα εργασίας',
    tabExceptions: 'Εξαιρέσεις & αργίες',
    tabSettings: 'Ρυθμίσεις',
    cancel: 'Ακύρωση',
    save: 'Αποθήκευση',
    saveReschedule: 'Αποθήκευση & επαναπρογραμματισμός',
    saveSetAsProject: 'Αποθήκευση & ορισμός ως έργου',
    unsavedChanges: '● Μη αποθηκευμένες αλλαγές',
    noChanges: 'Καμία αλλαγή',
    close: 'Κλείσιμο',

    weekQuick: 'Γρήγορη ρύθμιση:',
    presetMonFri: 'Δε–Πα',
    presetMonSat: 'Δε–Σα',
    presetAll: 'Όλες οι ημέρες',
    presetStandard: 'Standard 09–18',
    weekDay: 'Ημέρα',
    weekHours: 'Ώρες',
    weekTotal: (h: number) => `${h}ω / εβδομάδα`,
    addRange: '+ Διάστημα',
    nonWorkingDay: 'Μη εργάσιμη',
    from: 'Από',
    to: 'Έως',

    holidaysTitle: 'Αργίες έργου',
    holidaysActive: (on: number, total: number) => `${on} από ${total} ενεργές`,
    allOn: 'Όλες on',
    allOff: 'Όλες off',
    fetchingHolidays: 'Το AI φέρνει τις αργίες…',
    fetchHolidaysError: 'Δεν ήταν δυνατή η λήψη αργιών. Δοκιμάστε ξανά.',
    noHolidaysYet: 'Δεν έχουν οριστεί αργίες ακόμα. Ορίστε χώρα στο tab Ρυθμίσεις και πατήστε Υπολογισμός Αργιών.',
    exceptionsTitle: (n: number) => `Εξαιρέσεις · ${n}`,
    newException: '+ Νέα εξαίρεση',
    noExceptions: 'Καμία εξαίρεση ακόμα.',
    colName: 'Όνομα', colDates: 'Ημερομηνίες', colType: 'Τύπος', colRepeat: 'Επανάληψη',
    repeatOnce: 'Μία φορά', repeatWeekly: 'Κάθε εβδομάδα', repeatYearly: 'Κάθε χρόνο',
    typeOff: 'Μη εργάσιμη', typeWork: 'Εργάσιμη',

    hoursPerDay: 'Ώρες ανά ημέρα',
    hoursPerWeek: 'Ώρες ανά εβδομάδα',
    weekStarts: 'Η εβδομάδα ξεκινά',
    holidayCountry: 'Χώρα υπολογισμού αργιών',
    noCountrySet: 'Δεν έχει οριστεί χώρα',
    change: 'Αλλαγή',

    impactTitle: 'Επίπτωση στο έργο',
    impactFinish: 'Λήξη έργου',
    impactNoChange: 'χωρίς αλλαγή',
    impactDays: (sign: string, n: number) => `${sign}${n} ημ.`,
    impactMoved: (n: number) => `${n} activities μετακινούνται`,
    notProjectCalendar: (name: string) => `Επεξεργάζεστε το «${name}», που δεν είναι το ημερολόγιο του έργου. Οι αλλαγές του δεν επηρεάζουν το χρονοδιάγραμμα.`,
    willBecomeProjectCalendar: 'Θα οριστεί ως ημερολόγιο του έργου με την αποθήκευση — το χρονοδιάγραμμα θα επαναπρογραμματιστεί.',

    dlgExcTitle: 'Νέα εξαίρεση',
    dlgExcName: 'Όνομα', dlgExcNamePh: 'π.χ. Εκπαίδευση ομάδας',
    dlgExcFrom: 'Από', dlgExcTo: 'Έως', dlgExcType: 'Τύπος',
    dlgExcTypeOff: 'Μη εργάσιμη', dlgExcTypeOffSub: 'Αργία, άδεια, κλείσιμο',
    dlgExcTypeWork: 'Εργάσιμη / ειδικό ωράριο', dlgExcTypeWorkSub: 'π.χ. Σάββατο 08–14',
    dlgExcRepeat: 'Επανάληψη', dlgExcAdd: 'Προσθήκη',

    dlgNewTitle: 'Νέο ημερολόγιο',
    dlgNewName: 'Όνομα',
    dlgNewStartFrom: 'Ξεκινά από',
    dlgNewCopy: 'Αντίγραφο υπάρχοντος', dlgNewCopySub: 'Κρατά ωράρια & εξαιρέσεις',
    dlgNewBlank: 'Κενό', dlgNewBlankSub: 'Δε–Πα 09–17, χωρίς εξαιρέσεις',
    dlgNewAiHolidays: '✦ Αργίες με AI',
    dlgNewUseForProject: (project: string) => `Ορισμός ως ημερολόγιο του έργου ${project}`,
    dlgNewCreate: 'Δημιουργία',

    dlgDelTitle: (name: string) => `Διαγραφή «${name}»;`,
    dlgDelBody: 'Θα διαγραφούν η εβδομάδα εργασίας, οι εξαιρέσεις και οι αργίες του. Η ενέργεια ολοκληρώνεται με την αποθήκευση.',
    dlgDelInUse: 'Το έργο χρησιμοποιεί αυτό το ημερολόγιο. Επιλέξτε ποιο θα το αντικαταστήσει:',
    dlgDelConfirm: 'Διαγραφή',
    cantDeleteActiveCalendar: 'Είναι το ημερολόγιο του έργου — ορίστε πρώτα διαφορετικό για να το διαγράψετε',

    dlgCountryTitle: 'Χώρα αργιών',
    dlgCountryCountry: 'Χώρα',
    dlgCountryCity: 'Πόλη (προαιρετικό)',
    dlgCountrySubmit: 'Υπολογισμός Αργιών',
    dlgCountryTryAgain: 'Δοκιμάστε ξανά',
  },

  budget: {
    months: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μάι', 'Ιούν', 'Ιούλ', 'Αύγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'] as string[],
    tabDashboard: '📊 Dashboard',
    tabHR: '👥 Ανθρώπινο Δυναμικό',
    tabVendors: '🤝 Εξωτερικοί Συνεργάτες',
    tabBilling: '🧾 Τιμολόγηση Πελάτη',
    dashTitle: 'Βασικές Μεταβλητές',
    dashPerformance: 'Δείκτες Απόδοσης',
    dashForecasts: 'Εκτιμήσεις Ολοκλήρωσης',
    dashRemainingCost: 'Εναπομείναν κόστος',
    dashCostToDate: 'Κόστος μέχρι σήμερα',
    dashCostToday: 'Κόστος σήμερα',
    statusOnBudget: 'Εντός προϋπολογισμού',
    statusOnCost: 'Εντός κόστους ✓',
    statusUnderBudget: 'Κάτω του προϋπολογισμού',
    statusOverCost: 'Υπέρβαση κόστους ⚠',
    statusOverPct: 'Υπέρβαση %',
    statusNeedsImprovement: 'Απαιτείται βελτίωση ⚠',
    statusNonStdDeviation: 'Μη τυπικές αποκλίσεις',
    statusOnSchedule: 'Εντός χρονοδ. ✓',
    statusScheduleDelay: 'Χρονική καθυστέρηση ⚠',
    statusDelayPct: 'Καθυστέρηση %',
    statusExpectedDate: 'Αναμ. Ημ/νία',
    statusActualDate: 'Πραγμ. Ημ/νία',
    statusActualDateFull: 'Πραγμ. Ημερ.',
    statusPlannedDate: 'Προγρ. Ημερ.',
    labelDate: 'Ημερομηνία',
    totalContracts: 'Συνολικά Συμβόλαια',
    totalContract: 'Συνολικό Συμβόλαιο',
    totalHRBudget: 'Συνολικό Budget Α.Δ.',
    hrEnterMD: 'Εισάγετε MD ανά ομάδα στο Scope',
    hrNoEntries: 'Δεν έχει καταχωρηθεί',
    hrNoConsumption: 'Δεν υπάρχει κατανάλωση',
    hrFromActivities: 'Από κόστη δραστηριοτήτων',
    hrEmptyHint: 'Ξεκίνα από το tab "Ανθρώπινο Δυναμικό" ή "Εξωτερικοί Συνεργάτες".',
    teamNewBtn: 'Νέα Ομάδα Εργασίας',
    teamEditTitle: 'Επεξεργασία Ομάδας',
    teamDeleteTitle: 'Διαγραφή Ομάδας',
    vendorNewBtn: 'Νέος Εξωτερικός Συνεργάτης',
    vendorEditTitle: 'Επεξεργασία Συνεργάτη',
    vendorDeleteTitle: 'Διαγραφή Συνεργάτη',
    invoiceNewTitle: (name: string) => `Νέο Τιμολόγιο — ${name}`,
    invoiceEditTitle: 'Επεξεργασία Τιμολογίου',
    invoiceDeleteTitle: 'Διαγραφή Τιμολογίου',
    invoiceRecordBtn: 'Καταχώρηση τιμολογίου',
    invoiceMarkOverdueBtn: 'Σήμανση ως καθυστέρηση',
    billingNewBtn: 'Νέα Δόση Τιμολόγησης',
    billingEditTitle: 'Επεξεργασία Δόσης',
    billingDeleteTitle: 'Διαγραφή Δόσης',
    statusPending: 'Εκκρεμή',
    statusPendingSingle: 'Εκκρεμεί',
    statusInProgress: 'Εκτέλεση',
    statusOverdue: 'Ληξιπρόθεσμα',
    statusReceived: 'Ληφθέντα',
    statusInvoiced: 'Τιμολογήθηκε',
    fieldNote: 'Σημείωση',
    fieldAmount: 'Ποσό',
    fieldCondition: 'Προϋπόθεση',
    fieldAddToSchedule: 'Προσθήκη στο πρόγραμμα',
    fieldOptionalNote: 'Προαιρετική σημείωση...',
    placeholderTeamName: 'π.χ. Ομάδα Ανάπτυξης',
    placeholderTeamRole: 'π.χ. Senior Developers',
    placeholderBudgetCost: 'π.χ. 50000',
    placeholderBudgetMD: 'π.χ. 80',
    placeholderVendorName: 'π.χ. ABC Consulting',
    placeholderVendorRole: 'π.χ. Τεχνικός Σύμβουλος',
    placeholderContractAmount: 'π.χ. 20000',
    placeholderInvoiceAmount1: 'π.χ. 32000',
    placeholderInvoiceAmount2: 'π.χ. 15000',
    placeholderMilestone1: 'π.χ. 1η δόση — Υπογραφή σύμβασης',
    placeholderMilestone2: 'π.χ. Παράδοση Παραδοτέου Α και έγκριση πελάτη',
    placeholderMilestone3: 'π.χ. Παραδοτέο 2 — Ολοκλήρωση Ανάπτυξης',
    errorNoContract: 'Δεν βρέθηκε σύμβαση. Ανεβάστε πρώτα τη σύμβαση κατά τη δημιουργία του έργου.',
    errorAINoSchedule: 'Το AI δεν εντόπισε πρόγραμμα τιμολόγησης με επαρκή βεβαιότητα στη σύμβαση.',
    errorAI: 'Σφάλμα AI. Δοκίμασε ξανά.',
    errorAnalysis: 'Σφάλμα κατά την ανάλυση. Δοκίμασε ξανά.',
    errorInvalidResponse: 'Μη έγκυρη απάντηση',
    needsAC: 'Χρειάζεται AC',
    needsPV: 'Χρειάζεται PV',
    needsStartDate: 'Χρειάζεται ημ/νία έναρξης',
    unallocated: 'Αδιάθετες',
    easyCompletion: 'Εύκολη ολοκλήρωση ✓',
    expectedOverrun: 'Αναμενόμενη υπέρβαση',
    costMargin: 'Περιθώριο κόστους',
    excelHeaders: ['Τίτλος', 'Ρόλος', 'Budget MD', 'Budget Cost', 'Consumed MD', 'Consumed Cost', 'Remaining MD'] as string[],
    excelVendorHeaders: ['Συνεργάτης', 'Ρόλος', 'Σύμβαση', 'Καταβλήθηκαν', 'Εκκρεμούν', 'Ληξιπρόθεσμα'] as string[],
    excelBillingHeaders: ['Περιγραφή', 'Ποσό', 'Προϋπόθεση', 'Προγρ. Ημερ.', 'Status', 'Πραγμ. Ημερ.', 'Πραγμ. Ποσό'] as string[],
  },

  risk: {
    categories: ['Χρονικό', 'Οικονομικό', 'Τεχνικό', 'Νομικό/Συμβατικό', 'Οργανωτικό', 'Εξωτερικό'] as string[],
    scoreHigh: 'Υψηλό',
    scoreMedium: 'Μέτριο',
    scoreLow: 'Χαμηλό',
    matrixImpactAxis: 'Επίπτωση',
    matrixProbabilityAxis: 'Πιθανότητα',
    matrixImpactHigh: 'Υψηλή',
    matrixImpactMedium: 'Μέτρια',
    matrixImpactLow: 'Χαμηλή',
    matrixProbHigh: 'Υψηλή',
    matrixProbMedium: 'Μέτρια',
    matrixProbLow: 'Χαμηλή',
    legendLow: 'Χαμηλό (0-3.9)',
    legendMedium: 'Μέτριο (4-6.9)',
    legendHigh: 'Υψηλό (7-10)',
    tableHeaders: ['Τίτλος', 'Πιθ. (0-1)', 'Επίπτ. (0-10)', 'Βαθμολογία', 'Risk Owner', 'Status', 'Ενέργειες'] as string[],
    emptyState: 'Δεν υπάρχουν ρίσκα ακόμα.',
    aiBannerTitle: 'Ενημερώσεις από AI Επανανάλυση',
    aiNewRisks: (n: number) => `+${n} νέα ρίσκα`,
    aiSuggestions: (n: number) => `${n} προτάσεις επαναξιολόγησης`,
    aiSuggestionTitle: '✦ Πρόταση AI βάσει νέου εγγράφου',
    aiSuggestionNewProb: 'Νέα Πιθανότητα',
    aiSuggestionNewImpact: 'Νέα Επίπτωση',
    aiSuggestionReason: 'Λόγος αλλαγής',
    aiSuggestionNewMitigation: 'Νέα Πρόταση Αντιμετώπισης',
    aiAcceptBtn: '✓ Αποδοχή',
    aiRejectBtn: '✕ Απόρριψη',
    newBadge: '● Νέο',
    newBadgeHint: 'Κλικ για επιβεβαίωση',
    modalEditTitle: 'Επεξεργασία Ρίσκου',
    modalNewTitle: 'Νέο Ρίσκο',
    fieldTitle: 'Τίτλος *',
    fieldTitlePlaceholder: 'π.χ. Καθυστέρηση παράδοσης',
    fieldDescription: 'Περιγραφή',
    fieldDescriptionPlaceholder: 'Περιγραφή του ρίσκου...',
    fieldProbability: (v: number) => `Πιθανότητα (0-1): **${v}**`,
    fieldImpact: (v: number) => `Επίπτωση (0-10): **${v}**`,
    fieldScorePreview: (score: number, label: string) => `Βαθμολογία: ${score} — ${label}`,
    fieldOwner: 'Risk Owner',
    fieldOwnerPlaceholder: '— Επιλέξτε owner —',
    fieldOwnerNoStakeholders: 'Δεν υπάρχουν stakeholders — προσθέστε από το Stakeholder Register',
    fieldMitigation: 'Μέτρα Αντιμετώπισης',
    fieldMitigationPlaceholder: 'Πώς θα αντιμετωπιστεί το ρίσκο...',
    fieldMitigationAI: '🤖 Πρόταση ΑΙ',
    fieldStatus: 'Status',
    fieldComments: 'Σχόλια',
    btnAddRisk: '+ Νέο Ρίσκο',
    btnEditShort: 'Επεξ.',
    btnDeleteShort: 'Διαγρ.',
    excelHeaders: ['Τίτλος', 'Περιγραφή', 'Πιθανότητα (0-1)', 'Επίπτωση (0-10)', 'Βαθμολογία', 'Επίπεδο', 'Risk Owner', 'Μέτρα Αντιμετώπισης', 'Status'] as string[],
  },

  issues: {
    cardOpen: 'Ανοιχτά',
    cardInProgress: 'Σε Εξέλιξη',
    cardResolved: 'Επιλύθηκαν',
    cardTotal: 'Σύνολο',
    sectionHighPriority: '🚨 Υψηλής Προτεραιότητας',
    sectionByCategory: '📊 Ανά Κατηγορία',
    sectionByStatus: '📈 Ανά Status',
    emptyHighPriority: 'Δεν υπάρχουν ανοιχτά critical ή high issues!',
    emptyIssues: 'Δεν υπάρχουν issues ακόμα.',
    emptyIssuesSubtext: 'Τα issues καταγράφονται από την ομάδα όταν προκύπτουν προβλήματα.',
    tableHeaders: ['Τίτλος', 'Κατηγορία', 'Προτεραιότητα', 'Status', 'Owner', 'Deadline', 'Επίπτωση', 'Ενέργειες'] as string[],
    modalEditTitle: 'Επεξεργασία Issue',
    modalNewTitle: 'Νέο Issue',
    fieldTitle: 'Τίτλος *',
    fieldTitlePlaceholder: 'π.χ. Καθυστέρηση παράδοσης backend module',
    fieldDescription: 'Περιγραφή',
    fieldDescriptionPlaceholder: 'Αναλυτική περιγραφή του προβλήματος...',
    fieldCategory: 'Κατηγορία',
    fieldPriority: 'Προτεραιότητα',
    fieldStatus: 'Status',
    fieldOwner: 'Issue Owner',
    fieldOwnerPlaceholder: '— Επιλέξτε owner —',
    fieldOwnerNoStakeholders: 'Δεν υπάρχουν stakeholders — προσθέστε από το Stakeholder Register',
    fieldDateIdentified: 'Ημ. Εντοπισμού',
    fieldDeadline: 'Deadline Επίλυσης',
    fieldImpact: 'Επίπτωση στο Έργο',
    fieldActionPlan: 'Action Plan',
    fieldActionPlanPlaceholder: 'Τι ενέργειες λαμβάνονται για επίλυση...',
    fieldActionPlanAI: '🤖 Πρόταση ΑΙ',
    fieldRiskRef: 'Σύνδεση με Ρίσκο (προαιρετικό)',
    fieldRiskRefPlaceholder: 'π.χ. R-001 Καθυστέρηση ανάπτυξης',
    btnAddIssue: '+ Νέο Issue',
    excelHeaders: ['Τίτλος', 'Περιγραφή', 'Κατηγορία', 'Προτεραιότητα', 'Status', 'Owner', 'Ημ. Εντοπισμού', 'Deadline', 'Επίπτωση', 'Action Plan'] as string[],
  },

  stakeholders: {
    matrixInfluenceAxis: 'Επιρροή (Influence) →',
    matrixInterestAxis: 'Ενδιαφέρον (Interest) →',
    quadrantManageClosely: 'Υψηλή επιρροή & ενδιαφέρον',
    quadrantKeepSatisfied: 'Υψηλή επιρροή, χαμηλό ενδιαφέρον',
    quadrantKeepInformed: 'Χαμηλή επιρροή, υψηλό ενδιαφέρον',
    quadrantMonitor: 'Χαμηλή επιρροή & ενδιαφέρον',
    cardInfluence: 'Επιρροή',
    cardInterest: 'Ενδιαφέρον',
    cardStrategy: 'Στρατηγική:',
    emptyState: 'Δεν υπάρχουν stakeholders ακόμα.',
    emptySubtext: 'Πατήστε "+ Νέος Stakeholder" για δημιουργία',
    modalEditTitle: 'Επεξεργασία Stakeholder',
    modalNewTitle: 'Νέος Stakeholder',
    modalSyncNote: 'Οι αλλαγές στο Όνομα, Ρόλο, Οργανισμό και Email θα ενημερωθούν αυτόματα και στο Organization Chart',
    fieldName: 'Όνομα *',
    fieldNamePlaceholder: 'π.χ. Νίκος Αντωνίου',
    fieldTeam: 'Ομάδα',
    fieldTeamNone: '— Χωρίς ομάδα —',
    fieldRole: 'Ρόλος',
    fieldRolePlaceholder: 'π.χ. Project Sponsor',
    fieldOrganization: 'Οργανισμός',
    fieldOrganizationPlaceholder: 'π.χ. Κατασκευαστική Α.Ε.',
    fieldInfluence: (v: number) => `Επιρροή (0-5): **${v}**`,
    fieldInterest: (v: number) => `Ενδιαφέρον (0-5): **${v}**`,
    fieldQuadrant: (label: string) => `Τεταρτημόριο: **${label}**`,
    fieldEngagement: 'Engagement Level',
    fieldStrategy: 'Στρατηγική Διαχείρισης',
    fieldStrategyPlaceholder: 'Πώς θα διαχειριστείς αυτόν τον stakeholder...',
    btnAdd: '+ Νέος Stakeholder',
    excelHeaders: ['Όνομα', 'Ρόλος', 'Οργανισμός', 'Contact', 'Επιρροή (0-5)', 'Ενδιαφέρον (0-5)', 'Engagement', 'Τεταρτημόριο', 'Στρατηγική'] as string[],
  },

  dailyLog: {
    subtitle: 'Παρακολούθηση εργασιών και ημερήσιας προόδου',
    btnNew: '+ Νέα καταχώρηση',
    filterAllAssignees: '👤 Όλοι οι υπεύθυνοι',
    filterAllStatuses: '📋 Όλες οι καταστάσεις',
    filterClear: '✕ Καθαρισμός',
    noAssignee: 'Χωρίς ανάθεση',
    commentsLabel: 'σχόλια',
    dragHere: 'Σύρε εδώ',
    confirmDeleteTask: 'Διαγραφή task;',
    modalNewTitle: 'Νέα καταχώρηση',
    modalEditTitle: 'Επεξεργασία task',
    btnEdit: '✎ Επεξεργασία',
    btnCreate: 'Δημιουργία',
    createdBy: 'Δημιουργήθηκε',
    fieldAssignee: 'Υπεύθυνος',
    fieldAssigneePlaceholder: '— Επέλεξε υπεύθυνο —',
    fieldStatus: 'Κατάσταση',
    fieldCompletionDate: 'Ημ. Ολοκλήρωσης',
    fieldDeadline: 'Deadline',
    fieldDescription: 'Περιγραφή',
    fieldAttachments: '📎 Αρχεία',
    uploadBtn: '+ Ανέβασμα',
    uploadingBtn: 'Ανέβασμα...',
    noAttachments: 'Δεν υπάρχουν αρχεία.',
    deleteFileTitle: 'Διαγραφή αρχείου',
    deleteFileText: 'Αυτή η ενέργεια δεν αναιρείται',
    deleteFileLabel: 'Αρχείο',
    fieldComments: '💬 Σχόλια',
    noComments: 'Δεν υπάρχουν σχόλια ακόμα.',
    commentPlaceholder: 'Γράψε σχόλιο...',
    commentAdd: '+ Προσθήκη',
    fieldTitle: 'Τίτλος *',
    fieldTitlePlaceholder: 'π.χ. Έλεγχος παραδοτέων Φάσης Α',
    fieldDescPlaceholder: 'Αναλυτική περιγραφή...',
    fieldWorkPackage: 'Parent Work Package',
    fieldWorkPackagePlaceholder: 'π.χ. WP1: Ανάλυση',
    fieldActivity: 'Activity (από Schedule)',
    fieldActivityPlaceholder: '— Επέλεξε activity —',
    fieldCreationDate: 'Ημ. Δημιουργίας',
    daysToday: 'Σήμερα!',
    daysAbbr: 'ημ.',
    overdueMsg: (days: number) => `Overdue — ${days} ημέρες`,
    dueTodayMsg: 'Deadline σήμερα!',
    daysLeftMsg: (days: number) => `Απομένουν ${days} ημέρες`,
    dateLocale: 'el-GR',
    fieldCritical: 'Critical',
    fieldCriticalDesc: 'Σημαντικό / Critical',
    filterAllCritical: 'Όλα τα tasks',
    filterCriticalOnly: 'Μόνο Critical',
    filterNonCriticalOnly: 'Μη Critical',
  },

  orgChart: {
    tabTeam: 'Ομάδα Έργου',
    tabPairs: 'Ποιος μιλά με ποιον',
    aiGeneratedLabel: 'Από ανάλυση σύμβασης',
    btnCollapseAll: 'Σύμπτυξη όλων',
    btnExpandAll: 'Ανάπτυξη όλων',
    btnAddMember: '+ Προσθήκη μέλους',
    btnAddAbovePM: 'Προσθήκη πάνω από τον PM',
    emptyMembers: 'Δεν υπάρχουν μέλη ακόμα.',
    membersBadge: (n: number) => `${n} μέλη`,
    btnDefinePair: '+ Ορισμός Επαφής',
    btnDefinePairSmall: '+ Ορισμός επαφής',
    noClientContact: 'Χωρίς επαφή πελάτη',
    emptyPairs: 'Προσθέστε πρώτα μέλη στην Ομάδα Έργου.',
    modalEditMember: 'Επεξεργασία Μέλους',
    modalNewSubordinate: 'Νέο Υφιστάμενο',
    modalNewMember: 'Νέο Μέλος Ομάδας',
    subordinateOf: 'Υφιστάμενος του:',
    fieldName: 'Όνομα *',
    fieldFromStakeholder: '— Επέλεξε από Stakeholder Register —',
    stakeholderAutoFilled: '✦ Τα πεδία συμπληρώθηκαν αυτόματα από το Stakeholder Register',
    fieldTeam: 'Ομάδα',
    fieldTeamPlaceholder: 'π.χ. Μηχανικοί',
    fieldEditFromStakeholder: 'Επεξεργασία μόνο από το Stakeholder Register',
    fieldRole: 'Ρόλος *',
    fieldRolePlaceholder: 'π.χ. Μηχανικός Έργου',
    fieldOrganization: 'Εταιρεία / Οργανισμός',
    fieldOrganizationPlaceholder: 'π.χ. Κατασκευαστική Α.Ε.',
    fieldActivities: 'Ανατεθειμένες Activities από WBS',
    activitiesEmpty: 'Δεν υπάρχουν ανατεθειμένες activities ακόμα.',
    stakeholderRequired: 'Επέλεξε μέλος από το Stakeholder Register για να συνεχίσεις.',
    modalPairTitle: 'Ορισμός Επαφής Πελάτη',
    pairForMember: 'Για ποιο μέλος της ομάδας;',
    pairMemberPlaceholder: '-- Επέλεξε μέλος --',
    pairClientName: 'Όνομα επαφής πελάτη *',
    pairClientNamePlaceholder: 'π.χ. Νίκος Αντωνίου',
    pairRole: 'Ρόλος',
    pairRolePlaceholder: 'π.χ. Project Owner',
    pairCompany: 'Εταιρεία',
    pairCompanyPlaceholder: 'Εταιρεία πελάτη',
    pairChannels: 'Κανάλια Επικοινωνίας',
    pairFrequency: 'Συχνότητα',
    pairType: 'Τύπος',
    pairNote: 'Σημείωση',
    pairNotePlaceholder: 'Προαιρετική σημείωση...',
    channels: ['Email', 'Τηλέφωνο', 'Teams/Zoom', 'Slack', 'In-person'] as string[],
    frequencies: ['Ημερήσια', 'Εβδομαδιαία', 'Δεκαπενθήμερη', 'Μηνιαία', "Κατ'ανάγκη"] as string[],
    types: ['Τακτική', 'Έκτακτη', 'Αναφορά', 'Έγκριση'] as string[],
    defaultFrequency: 'Εβδομαδιαία',
    defaultType: 'Τακτική',
    statusCompleted: 'Ολοκληρώθηκε',
    statusInProgress: 'Σε εξέλιξη',
    statusDelayed: 'Καθυστέρηση',
    statusNotStarted: 'Δεν ξεκίνησε',
  },

  aiAdvisor: {
    subtitle: 'Προτάσεις βάσει transcripts και emails — αποδέξου ή απόρριψε κάθε ενέργεια',
    pendingBadge: (n: number) => `${n} εκκρεμείς προτάσεις`,
    filterPending: 'Εκκρεμείς',
    filterAll: 'Όλα',
    filterAccepted: 'Αποδεκτά',
    filterRejected: 'Απορριφθέντα',
    emptyPendingTitle: 'Δεν υπάρχουν εκκρεμείς προτάσεις',
    emptyTitle: 'Δεν υπάρχουν προτάσεις',
    emptyPendingDesc: 'Δεν υπάρχουν εκκρεμείς προτάσεις — νέα insights παράγονται αυτόματα από transcripts και emails',
    emptyFilterDesc: 'Δεν υπάρχουν insights για αυτό το φίλτρο',
    acceptAll: '✓ Αποδοχή όλων',
    dismiss: 'Απόρριψη',
    statusAccepted: '✓ Αποδεκτό',
    statusRejected: '✕ Απορρίφθηκε',
    suggestedActions: 'Προτεινόμενες Ενέργειες',
    probLabel: 'Πιθ',
    impactLabel: 'Επίδ',
    actionDone: '✓ Έγινε',
    actionRejected: '✕ Απορρίφθηκε',
    timeJustNow: 'μόλις τώρα',
    timeMinutes: (m: number) => `${m}λ πριν`,
    timeHours: (h: number) => `${h}ω πριν`,
    actionLabels: {
      add_risk: '⚠️ Προσθήκη Ρίσκου',
      update_risk: '✏️ Ενημέρωση Ρίσκου',
      add_issue: '🔧 Δημιουργία Issue',
      update_schedule: '📅 Σημείωση Schedule',
    } as Record<string, string>,
  },

  lessonsLearned: {
    addLesson: '+ Νέο Lesson',
    emptyTitle: 'Δεν υπάρχουν καταγεγραμμένα lessons ακόμα.',
    emptyDesc: 'Τα lessons learned καταγράφονται κατά την αρχειοθέτηση του έργου ή μπορείς να προσθέσεις νέο οποιαδήποτε στιγμή.',
    addFirstLesson: '+ Πρόσθεσε Lesson',
    labelWentWell: '✅ Τι πήγε καλά',
    labelWentWrong: '❌ Τι δεν πήγε καλά',
    labelKeyLessons: '💡 Κύρια Μαθήματα',
    labelRisksRealized: '⚠️ Ρίσκα που υλοποιήθηκαν',
    labelSuggestions: 'Προτάσεις:',
    modalTitle: '📝 Νέο Lesson Learned',
    fieldType: 'Τύπος Έργου',
    fieldTypePlaceholder: 'π.χ. SaaS Ανάπτυξη, Κατασκευή...',
    fieldRating: 'Συνολική Αξιολόγηση:',
    ratingBad: '1 ⭐ Κακό',
    ratingMedium: '3 ⭐ Μέτριο',
    ratingExcellent: '5 ⭐ Εξαιρετικό',
    fieldWentWell: '✅ Τι πήγε καλά;',
    fieldWentWellPlaceholder: 'Ποιες πρακτικές λειτούργησαν καλά...',
    fieldWentWrong: '❌ Τι δεν πήγε καλά;',
    fieldWentWrongPlaceholder: 'Ποια προβλήματα προέκυψαν...',
    fieldKeyLessons: '💡 Κύρια Μαθήματα',
    lessonPlaceholder: (i: number) => `Μάθημα ${i + 1}...`,
    fieldRisks: '⚠️ Ρίσκα που υλοποιήθηκαν',
    riskPlaceholder: (i: number) => `Ρίσκο ${i + 1}...`,
    fieldScheduleDelays: '📅 Καθυστερήσεις Schedule',
    scheduleDelaysPlaceholder: 'π.χ. +2 μήνες λόγω...',
    fieldBudgetVariance: '💰 Απόκλιση Budget',
    budgetVariancePlaceholder: 'π.χ. +15% λόγω...',
    fieldSuggestions: '🔮 Προτάσεις για μελλοντικά έργα',
    suggestionsPlaceholder: 'Τι θα έκανες διαφορετικά...',
  },

  projectSpecs: {
    sectionBasic: 'Βασικά Στοιχεία',
    fieldProjectName: 'Όνομα Έργου',
    fieldDescription: 'Περιγραφή',
    fieldStatus: 'Κατάσταση',
    fieldStatusActive: '● Ενεργό',
    fieldCreatedAt: 'Ημερομηνία Δημιουργίας',
    fieldProjectId: 'Project ID',
    sectionAI: 'AI Status',
    fieldAIAnalysis: 'AI Ανάλυση',
    fieldAIDone: '✓ Ολοκληρώθηκε',
    fieldAINotRun: '✕ Δεν έχει τρέξει',
    fieldTranscripts: (n: number) => `${n} ανεβασμένα`,
    fieldPendingInsights: 'Εκκρεμείς Προτάσεις AI',
    fieldPendingCount: (n: number) => `${n} εκκρεμείς`,
    fieldPendingNone: '✓ Καμία εκκρεμής',
    sectionEmail: 'Email Integration',
    gmailNotConnected: 'Το Gmail δεν έχει συνδεθεί',
    gmailConnectWarning: 'Απαιτείται σύνδεση για να ενεργοποιηθεί το email integration',
    gmailConnect: '🔗 Σύνδεση Gmail',
    gmailConnected: 'Gmail συνδεδεμένο',
    gmailPolling: '● Polling ενεργό',
    gmailDisconnect: 'Αποσύνδεση',
    gmailDisconnectConfirm: 'Αποσύνδεση Gmail από αυτό το project;',
    emailLabel: 'Email Integration για αυτό το έργο',
    emailHint: 'Βάλε το project email ως CC στην αλληλογραφία',
    emailToggleTip: 'Πρόσθεσε πρώτα project email',
    emailProjectLabel: 'Project Email (που σου έδωσε το IT)',
    emailPlaceholder: 'π.χ. project_abc@company.gr',
    emailSave: 'Αποθήκευση',
    emailCopied: '✓ Αντιγράφηκε',
    emailCopy: '📋 Αντιγραφή',
    emailAnalysisNote: '✓ Κάθε email που λαμβάνεις με αυτό το CC θα αναλύεται αυτόματα από το AI',
    sectionSources: 'Πηγές Δεδομένων AI',
    sources: [
      { icon: '📄', label: 'Σύμβαση / RFO', desc: 'Αρχική ανάλυση κατά τη δημιουργία' },
      { icon: '📁', label: 'Λοιπά Έγγραφα', desc: 'Αυτόματη επανανάλυση σε κάθε upload' },
      { icon: '🎙️', label: 'Transcripts Συναντήσεων', desc: 'Ανάλυση κάθε νέου transcript' },
      { icon: '📋', label: 'Task Tracker Tasks', desc: 'Kanban tasks ως knowledge του έργου' },
      { icon: '📧', label: 'Email Αλληλογραφία', desc: 'Ανάλυση εισερχόμενης αλληλογραφίας' },
    ] as { icon: string; label: string; desc: string }[],
  },

  transcript: {
    pageTitle: 'Transcripts Συναντήσεων',
    subtitle: 'Ανέβασε transcripts — το AI αναλύει και ενημερώνει αυτόματα τα modules',
    newTranscript: '+ Νέο Transcript',
    emptyTitle: 'Δεν υπάρχουν transcripts ακόμα',
    aiProcessed: '✦ AI Αναλύθηκε',
    aiProcessing: '⏳ Σε επεξεργασία',
    aiProcessingLong: '⏳ Σε επεξεργασία από AI...',
    noContent: 'Δεν υπάρχει περιεχόμενο',
    aiNote: '✦ Το AI ανέλυσε αυτό το transcript — δες τις προτάσεις στο AI Advisor',
    selectHint: 'Επέλεξε ένα transcript για να δεις το περιεχόμενό του',
    uploadModalTitle: 'Νέο Transcript',
    fieldTitle: 'Τίτλος Συνάντησης *',
    fieldTitlePlaceholder: 'π.χ. Kick-off Meeting με πελάτη',
    fieldDate: 'Ημερομηνία Συνάντησης',
    fieldMeeting: 'Σύνδεση με συνάντηση (προαιρετικό)',
    fieldMeetingNone: '— Καμία —',
    fieldFile: 'Αρχείο Transcript *',
    dropHint: 'Σύρε αρχείο ή κλικ για επιλογή',
    aiUploadNote: '✦ Το AI θα αναλύσει αυτόματα το transcript και θα δημιουργήσει προτάσεις στο AI Advisor',
    uploading: '⏳ Ανέβασμα...',
    uploadBtn: 'Ανέβασμα',
    deleteTitle: 'Διαγραφή Transcript',
    deleteSubtitle: 'Αυτή η ενέργεια δεν αναιρείται',
    deleteConfirm: 'Διαγραφή',
    timeJustNow: 'μόλις τώρα',
    timeMinutes: (m: number) => `${m}λ πριν`,
    timeHours: (h: number) => `${h}ω πριν`,
  },

  meetings: {
    title: 'Συναντήσεις',
    newMeeting: '+ Νέα Συνάντηση',
    empty: 'Δεν υπάρχουν συναντήσεις ακόμα.',
    backToList: 'Πίσω στις συναντήσεις',
    participants: 'Συμμετέχοντες',
    agenda: 'Agenda',
    generate: '✦ Δημιουργία Agenda',
    regenerate: '✦ Αναδημιουργία Agenda',
    generating: '⏳ Δημιουργία...',
    noAgenda: 'Δεν έχει δημιουργηθεί agenda. Πάτησε "Δημιουργία Agenda" για να προτείνει το AI θέματα με βάση τα ανοιχτά ζητήματα του έργου και τους συμμετέχοντες.',
    genDone: 'Το AI πρότεινε {n} θέμα(τα) για αυτή τη συνάντηση.',
    genNoOpenItems: 'Δεν υπάρχουν ανοιχτά Issues / Risks / Tasks στο έργο — δεν υπάρχει υλικό για agenda ακόμα.',
    genNoMatch: 'Ελέγχθηκαν {n} ανοιχτά ζητήματα, αλλά το AI δεν έκρινε κάποιο σχετικό με τους συμμετέχοντες. Πρόσθεσε θέματα χειροκίνητα ή άλλαξε τους συμμετέχοντες.',
    genNoParticipants: 'Δεν έχεις ορίσει συμμετέχοντες — μπήκαν αυτόματα μόνο τα {n} πιο κρίσιμα ζητήματα. Όρισε συμμετέχοντες για στοχευμένη agenda.',
    genCapped: '(+{n} ακόμη ζητήματα στα «Άλλα ανοιχτά ζητήματα» πιο κάτω.)',
    genError: 'Απέτυχε η δημιουργία agenda.',
    participantScope: 'Ομάδες / οργανισμοί',
    otherOpen: 'Άλλα ανοιχτά ζητήματα',
    transcriptLabel: 'Transcript',
    transcriptLinked: 'Συνδεδεμένο',
    pickTranscript: '-- Επίλεξε transcript --',
    processing: 'σε επεξεργασία',
    noTranscripts: 'Δεν υπάρχουν transcripts στο έργο. Ανέβασέ τα από το module Transcripts.',
    link: 'Σύνδεση',
    unlink: 'Αποσύνδεση',
    lastMatch: 'Τελευταία αντιστοίχιση',
    completeBtn: '✓ Ολοκλήρωση συνάντησης',
    completeTitle: 'Ολοκλήρωση συνάντησης',
    completeHint: 'Η τρέχουσα agenda «παγώνει» ως snapshot και η συνάντηση περνά σε κατάσταση «Ολοκληρώθηκε». Μετά μπορείς να τρέξεις αντιστοίχιση με το transcript.',
    completeConfirm: 'Ολοκλήρωση',
    matchBtn: '✦ Αντιστοίχιση με transcript',
    rematchBtn: '✦ Επανάληψη αντιστοίχισης',
    matching: '⏳ Αντιστοίχιση...',
    matchNeedsTranscript: 'Σύνδεσε πρώτα ένα transcript',
    matchDone: 'Η αντιστοίχιση ολοκληρώθηκε — δες τα αποτελέσματα ανά θέμα.',
    matchError: 'Απέτυχε η αντιστοίχιση με το transcript.',
    completedMsg: 'Η συνάντηση ολοκληρώθηκε. Σύνδεσε/ανέβασε transcript και τρέξε αντιστοίχιση.',
    outcome: {
      discussed_resolved: 'Λύθηκε',
      decision_made: 'Απόφαση',
      discussed_open: 'Παραμένει ανοιχτό',
      not_discussed: 'Δεν συζητήθηκε',
    } as Record<string, string>,
    proposalTitle: 'Πρόταση ενημέρωσης',
    proposalStatus: 'Νέο status',
    proposalNote: 'Σημείωση',
    applyBtn: 'Εφαρμογή',
    dismissBtn: 'Απόρριψη',
    applied: 'Εφαρμόστηκε',
    newActionsTitle: 'Νέες ενέργειες από τη συνάντηση',
    createTaskBtn: '+ Δημιουργία task',
    generalNotesTitle: 'Γενικές σημειώσεις (εκτός agenda)',
    createBtn: 'Δημιουργία',
    noDate: 'Χωρίς ημερομηνία',
    today: 'Σήμερα',
    addTopic: '+ Προσθήκη θέματος',
    addAdhoc: 'Ελεύθερο θέμα',
    addLinked: 'Από ανοιχτά ζητήματα',
    topicPh: 'Περιγραφή θέματος...',
    pickItem: '-- Επίλεξε ζήτημα --',
    noteTalkingPoint: 'Talking point',
    noteDecision: 'Απόφαση',
    notesPh: 'Σημειώσεις / talking points για αυτό το θέμα...',
    fieldTitle: 'Τίτλος',
    fieldType: 'Τύπος',
    fieldTypePh: 'π.χ. εβδομαδιαίο sync, steering committee, ad-hoc',
    fieldDate: 'Ημερομηνία',
    fieldParticipants: 'Συμμετέχοντες (από το Stakeholder Register)',
    noStakeholders: 'Δεν υπάρχουν stakeholders — πρόσθεσέ τους πρώτα στο module Stakeholders.',
    confirmDelete: 'Διαγραφή συνάντησης',
    status: {
      draft: 'Πρόχειρο',
      agenda_ready: 'Agenda έτοιμη',
      held: 'Ολοκληρώθηκε',
      closed: 'Κλειστό',
    } as Record<string, string>,
    category: {
      decision_needed: 'Χρειάζεται απόφαση από αυτούς',
      blocked_on_them: 'Είμαστε blocked — περιμένουμε αυτούς',
      update_for_them: 'Ενημέρωση προς αυτούς',
      risk_to_flag: 'Ρίσκο προς επισήμανση',
      other: 'Άλλα',
    } as Record<string, string>,
  },

  scope: {
    statusLabels: {
      completed: 'Ολοκληρώθηκε',
      in_progress: 'Σε εξέλιξη',
      delayed: 'Καθυστέρηση',
      not_started: 'Δεν ξεκίνησε',
    } as Record<string, string>,
    aiBadge: '✦ AI-generated · Από ανάλυση σύμβασης',
    statUnassigned: 'Αδιάθετες',
    statCompletion: 'Ολοκλήρωση',
    hintDragWP: '⠿ Σύρε <strong>Work Packages</strong> για αλλαγή σειράς',
    hintDragActivity: '⠿ Σύρε <strong>Activity</strong> εντός WP για reorder ή σε άλλο WP για μεταφορά',
    hintDetails: '⋯ Κλικ για λεπτομέρειες / Εκτίμηση Υλοποίησης',
    emptyTitle: 'Δεν υπάρχουν Work Packages ακόμα',
    emptyDescEdit: 'Δημιούργησε Work Packages χειροκίνητα ή άφησε το AI να αναλύσει τη σύμβαση.',
    emptyDescView: 'Δεν υπάρχουν Work Packages για αυτό το έργο.',
    aiConfirmTitle: 'AI Δημιουργία WBS',
    aiConfirmSubtitle: 'Αυτόματη ανάλυση από τη σύμβαση',
    aiConfirmWarning: 'Το AI θα δημιουργήσει αυτόματα Work Packages από τη σύμβαση. Τυχόν υπάρχοντα Work Packages θα αντικατασταθούν.',
    deleteWPTitle: 'Διαγραφή Work Package',
    deleteWPSubtitle: 'Αυτή η ενέργεια δεν αναιρείται',
    deleteWPActivitiesSingle: 'Η 1 ανατεθειμένη activity θα γίνει αδιάθετη και δεν θα χαθεί.',
    deleteWPActivitiesMultiple: (n: number) => `Οι ${n} ανατεθειμένες activities θα γίνουν αδιάθετες και δεν θα χαθούν.`,
    modalEditWP: 'Επεξεργασία Work Package',
    modalNewWP: 'Νέο Work Package',
    titleLabel: 'Τίτλος *',
    descriptionLabel: 'Περιγραφή',
    descriptionPlaceholder: 'Σύντομη περιγραφή...',
    mdLabel: 'Εκτίμηση Υλοποίησης σε Ανθρωποημέρες (MD)',
    assignHint: 'Επέλεξε activities. Τα ήδη ανατεθειμένα σε άλλα WP δεν εμφανίζονται.',
    assignedSectionTitle: (n: number) => `✅ Ανατεθειμένα (${n})`,
    availableSectionTitle: (n: number) => `📋 Διαθέσιμες (${n})`,
    allAssigned: 'Όλες οι activities έχουν ανατεθεί.',
    actDetailTitle: 'Λεπτομέρειες Activity',
    actNameLabel: 'Όνομα',
    actNameHint: '📌 Διαχείριση από Schedule',
    actDescLabel: 'Περιγραφή',
    actDescEmpty: 'Δεν υπάρχει περιγραφή',
    actAssigneeLabel: 'Ανάθεση σε μέλη ομάδας',
    actAssigneeEmpty: 'Δεν έχει ανατεθεί',
    actMDLabel: 'MD ανά Ομάδα',
    actNoTeams: 'Δεν υπάρχουν ομάδες στο Budget → Ανθρώπινο Δυναμικό.',
    actTotal: (md: number) => `Σύνολο: ${md} MD`,
    actWBSLabel: 'Κωδικός WBS',
    actStatusLabel: 'Κατάσταση',
    dragHandleTip: 'Σύρε για αλλαγή σειράς WP',
    actDragHandleTip: 'Σύρε',
    dropZoneHint: 'Άφησε εδώ',
    assignBtn: '+ Ανάθεση Activities',
    availablePanel: (n: number) => `📋 Αδιάθετες Activities (${n})`,
    availablePanelHint: ' — Δεν έχουν ανατεθεί σε κανένα Work Package',
    errorGenerate: 'Σφάλμα κατά τη δημιουργία. Δοκίμασε ξανά.',
    btnBack: 'Επιστροφή',
    btnContinue: 'Συνέχεια',
    btnClose: 'Κλείσιμο',
    btnAssign: '+ Ανάθεση',
  },

  documents: {
    pageTitle: 'Διαχειριστικά Έγγραφα',
    tabDeliverables: 'Παραδοτέα Σύμβασης',
    tabOther: 'Λοιπά Έγγραφα',
    deliverablesTitle: 'Παραδοτέα Σύμβασης',
    deliverablesSubtitle: 'Κεφάλαια, υποκεφάλαια και συμπλήρωση με ΑΙ',
    newDeliverable: '+ Νέο Παραδοτέο',
    emptyDelTitle: 'Δεν υπάρχουν παραδοτέα ακόμα',
    emptyDelDesc: 'Δημιούργησε το πρώτο παραδοτέο με κεφάλαια και υποκεφάλαια.',
    createDeliverable: '+ Δημιουργία Παραδοτέου',
    chaptersLabel: (n: number) => `${n} κεφάλαια`,
    deleteLabel: '🗑 Διαγραφή',
    deleteDeliverableTitle: 'Διαγραφή Παραδοτέου',
    deleteDocTitle: 'Διαγραφή Εγγράφου',
    deleteSubtitle: (title: string) => `"${title}" — η ενέργεια δεν αναιρείται`,
    deleteConfirmLabelPre: 'Πληκτρολογήστε',
    deleteConfirmLabelPost: 'για επιβεβαίωση',
    statusDefault: 'Εκκρεμεί',
    modalNewDel: 'Νέο Παραδοτέο',
    modalEditDel: 'Επεξεργασία Παραδοτέου',
    fieldTitle: 'ΤΙΤΛΟΣ *',
    fieldTitlePlaceholder: 'π.χ. Τεχνική Έκθεση Φάσης 1',
    fieldDescription: 'ΠΕΡΙΓΡΑΦΗ',
    fieldCategory: 'ΚΑΤΗΓΟΡΙΑ',
    fieldDeadline: 'ΠΡΟΘΕΣΜΙΑ',
    fieldStatus: 'STATUS',
    statusOptions: ['Εκκρεμεί', 'In Progress', 'Completed'] as string[],
    fieldChapters: 'ΚΕΦΑΛΑΙΑ',
    chapterPlaceholder: 'Τίτλος κεφαλαίου...',
    addChapter: '+ Προσθήκη',
    createBtn: 'Δημιουργία',
    deleteConfirmWord: 'Διαγραφή',
    deletePlaceholder: 'Διαγραφή',
    backBtn: '← Επιστροφή',
    editBtn: '✎ Επεξεργασία',
    noChapters: 'Δεν υπάρχουν κεφάλαια.',
    addChapterLink: '+ Πρόσθεσε κεφάλαιο',
    addSubChapter: '+ υποκεφάλαιο',
    newChapterBtn: '+ Νέο κεφάλαιο',
    renameTip: 'Διπλό κλικ για μετονομασία',
    fillWithAITitle: 'Συμπλήρωση κεφαλαίου με ΑΙ',
    fillSubWithAITitle: 'Συμπλήρωση υποκεφαλαίου με ΑΙ',
    downloadDocx: '⬇ Λήψη .docx',
    fillActiveBtn: '⟳ Επεξεργασία...',
    fillBtn: '✦ Συμπλήρωσε με ΑΙ',
    aiFillingNote: '✦ Το ΑΙ αναλύει τα έγγραφα του έργου και γράφει το περιεχόμενο...',
    selectChapter: 'Επιλέξτε κεφάλαιο ή υποκεφάλαιο από αριστερά',
    addDocument: 'Προσθήκη Εγγράφου',
    addDocumentHint: 'PDF & DOCX αναλύονται αυτόματα από το ΑΙ',
    categoryLabel: 'Κατηγορία',
    uploadHint: 'Σύρε ή επίλεξε αρχείο',
    uploadingHint: 'Ανέβασμα & ανάλυση ΑΙ...',
    knowledgeTitle: '🧠 Τι γνωρίζει το ΑΙ',
    knowledgeSubtitle: 'Βάσει των αναλυμένων εγγράφων',
    analyzeBtn: '↻ Ανάλυση',
    knowledgeEmptyHint: 'Ανέβασε έγγραφα για να δεις τι έχει καταλάβει το ΑΙ για αυτό το έργο.',
    knowledgeReadingHint: '✦ Το ΑΙ διαβάζει τα έγγραφα...',
    analyzeClickHint: 'Πάτησε "Ανάλυση" για να δεις τι έχει κατανοήσει το ΑΙ.',
    knowledgeScope: 'Αντικείμενο',
    knowledgeClient: 'Πελάτης',
    knowledgeContractor: 'Ανάδοχος',
    knowledgeBudget: 'Προϋπολογισμός',
    knowledgeDuration: 'Διάρκεια',
    knowledgeObjectives: 'Στόχοι',
    knowledgeConstraints: 'Βασικοί Περιορισμοί',
    knowledgeTechnical: 'Τεχνικά Highlights',
    statsTotalDocs: 'Σύνολο εγγράφων',
    statsAIAnalysed: 'Αναλύθηκαν από ΑΙ',
    knowledgeBaseEmpty: 'Η βάση γνώσης είναι κενή',
    knowledgeBaseEmptyDesc: 'Ανέβασε τη σύμβαση, τεχνικές προδιαγραφές ή οποιοδήποτε έγγραφο με πληροφορίες για το έργο.',
    filesCount: (n: number) => `${n} αρχεί${n === 1 ? 'ο' : 'α'}`,
    docAnalysed: '✓ Αναλύθηκε',
    docFile: 'Αρχείο',
    viewDoc: '👁 Προβολή',
    viewDocError: 'Δεν ήταν δυνατή η προβολή του αρχείου.',
    savingBtn: 'Αποθήκευση...',
    savedBtn: '✓ Αποθηκεύτηκε',
    subChapterPlaceholder: 'Τίτλος υποκεφαλαίου...',
    categories: [
      { id: 'Σύμβαση', label: 'Σύμβαση', icon: '📜', desc: 'Κύρια σύμβαση & τροποποιήσεις' },
      { id: 'Τεχνικές Προδιαγραφές', label: 'Τεχνικές Προδιαγραφές', icon: '⚙️', desc: 'Τεχνικά έγγραφα & specs' },
      { id: 'Μελέτες', label: 'Μελέτες', icon: '🔬', desc: 'Αναλύσεις & εκθέσεις' },
      { id: 'Οικονομικά', label: 'Οικονομικά', icon: '💰', desc: 'Προϋπολογισμός & οικονομικά' },
      { id: 'Άλλα', label: 'Άλλα', icon: '📎', desc: 'Λοιπά σχετικά έγγραφα' },
    ] as { id: string; label: string; icon: string; desc: string }[],
  },
  reporting: {
    title: 'Αναφορές',
    newReport: '+ Νέα Αναφορά',
    newReportPlaceholder: 'Όνομα αναφοράς...',
    create: 'Δημιουργία',
    noReports: 'Δεν υπάρχουν αναφορές',
    noReportsHint: 'Δημιουργήστε την πρώτη αναφορά για αυτό το έργο',
    selectReport: 'Επιλέξτε αναφορά από τη λίστα',
    addBlock: '+ Προσθήκη στοιχείου',
    noBlocks: 'Η αναφορά είναι κενή',
    noBlocksHint: 'Προσθέστε στοιχεία από τα modules του έργου',
    noData: 'Δεν υπάρχουν δεδομένα',
    deleteReport: 'Διαγραφή αναφοράς',
    deleteReportConfirm: 'Διαγραφή αναφοράς;',
    deleteReportHint: 'Αυτή η ενέργεια δεν αναιρείται.',
    renameReport: 'Μετονομασία',
    dragHint: 'Σύρε για αναδιάταξη',
    sources: {
      Schedule: 'Χρονοδιάγραμμα',
      Budget: 'Προϋπολογισμός',
      'Risk Management': 'Ρίσκα',
      Issues: 'Issues',
    } as Record<string, string>,
    blocks: {
      schedule_phases: 'Πρόοδος Φάσεων',
      schedule_milestones: 'Ορόσημα',
      budget_evm: 'EVM — Δείκτες Απόδοσης',
      budget_client_billing: 'Τιμολογήσεις Πελάτη',
      budget_vendors: 'Προμηθευτές',
      risk_top: 'Κορυφαία Ρίσκα',
      risk_summary: 'Σύνοψη Ρίσκων',
      issues_open: 'Ανοιχτά Issues',
      issues_critical: 'Κρίσιμα Issues',
    } as Record<string, string>,
  },
};

const en: typeof el = {
  common: {
    myProjects: 'My Projects',
    loading: 'Loading...',
    saving: 'Saving...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    deleteTip: 'Delete',
    editTip: 'Edit',
    edit: 'Edit',
    readOnly: '👁 Read only',
    exportWord: '⬇ Export to Word',
    exportExcel: '⬇ Export to Excel',
    createAI: '✦ Create with AI',
    regenerateAI: '✦ Regenerate with AI',
    generating: '⏳ Generating...',
    addItem: '+ Add',
    back: 'Back',
    continue: 'Continue',
    aiConfirmSubtitle: 'Automatic analysis from the contract',
    dateLocale: 'en-US',
    wordFooter: (name: string, date: string) => `Created by: ${name} | ${date}`,
  },

  projectCharter: {
    pageTitle: 'Project Charter',
    generatingTitle: 'Generating Project Charter...',
    analyzingContract: 'Analyzing contract',
    emptyState: 'No data yet. Use the "✦ Create with AI" button or upload a contract document.',
    sectionScope: 'Project Scope',
    sectionObjectives: 'Objectives',
    sectionDeliverables: 'Deliverables',
    sectionStakeholders: 'Stakeholders',
    sectionBudget: 'Budget',
    sectionDuration: 'Duration',
    aiConfirmTitle: 'AI Generate Project Charter',
    aiConfirmWarning: 'The AI will automatically generate the Project Charter from the contract. Any existing data will be replaced.',
    errorGenerate: 'Error during generation. Please try again.',
  },

  kickoff: {
    subtitle: 'Project kickoff presentation — bullet points for PowerPoint',
    generatingTitle: 'Preparing Kickoff Presentation...',
    analyzingContract: 'Analyzing contract and risks',
    emptyTitle: 'No Kickoff Presentation yet',
    emptyDesc: 'Click "✦ Create with AI" to automatically generate the kickoff presentation based on the contract',
    addBullet: '+ Add bullet',
    noData: 'No data',
    aiConfirmTitle: 'AI Generate Kickoff Presentation',
    aiConfirmWarning: 'The AI will automatically generate the Kickoff Presentation from the contract. Any existing data will be replaced.',
    sections: {
      project_purpose: 'Project Purpose',
      project_scope: 'Project Scope',
      technical_solution: 'Technical Solution Description',
      key_risks: 'Key Risks',
      prerequisites: 'Key Prerequisites',
      next_steps: 'Next Steps',
    } as Record<string, string>,
  },

  schedule: {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'] as string[],
    days: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'] as string[],
    statusLabels: {
      not_started: 'Not Started',
      in_progress: 'In Progress',
      completed: 'Completed',
      delayed: 'Delayed',
    } as Record<string, string>,
    summaryPhases: 'Phases',
    summaryDays: 'Days',
    summaryStart: 'Start',
    summaryEnd: 'End',
    legendCompleted: 'Completed',
    legendToday: 'Today',
    legendDependency: 'Dependency',
    checkCriticalOnly: 'Critical Path',
    btnToday: 'Today',
    btnNewPhase: '+ New Phase',
    btnNewActivity: '+ New Activity',
    defaultPhaseTitle: 'Unassigned',
    emptyState: 'No schedule data yet.',
    hintInline: '💡 Click on days for inline editing',
    hintDrag: 'Drag to reorder',
    hintDoubleClick: 'Double-click to rename',
    aiConfirmTitle: 'AI Generate Schedule',
    aiConfirmWarning: 'The AI will automatically generate the Schedule from the contract and Project Charter. Any existing schedule will be replaced.',
    errorGenerate: 'Error generating schedule. Please try again.',
    phaseModalTitle: 'New Phase',
    phaseNameLabel: 'Phase Name *',
    phaseNamePlaceholder: 'e.g. Phase 3: Testing',
    phaseDescLabel: 'Phase Description',
    phaseColorLabel: 'Color',
    phasePositionLabel: 'Position in Schedule',
    phasePositionStart: '↑ At the beginning (before all)',
    phasePositionAfter: (title: string) => `After: ${title}`,
    phasePositionEnd: '↓ At the end (after all)',
    hintDragBars: '💡 Drag bars to change dates',
    activityModalEditTitle: 'Edit',
    activityModalNewTitle: 'New Activity / Milestone',
    fieldType: 'Type',
    fieldWorkPackage: 'Work Package',
    fieldWorkPackageReadonly: '— Defined by Scope —',
    fieldPhase: 'Phase',
    fieldPhasePlaceholder: '-- Select phase --',
    fieldTitle: 'Title *',
    fieldDescription: 'Description',
    fieldStartDate: 'Start Date',
    fieldEndDate: 'End Date',
    fieldDuration: 'Duration (days)',
    fieldDeps: 'Dependencies',
    fieldDepsEmpty: 'No other activities yet.',
    fieldAssign: 'Assign to',
    fieldAssignEmpty: 'No stakeholders in Stakeholders Register yet.',
    fieldStatus: 'Status',
    fieldProgress: '% Progress',
    fieldProgressHelper: '— updated from AC entries',
    detailDescription: 'Description',
    detailDeps: 'Dependencies',
    detailAssign: 'Assignment',
    detailAC: 'Actual Man-Days (AC)',
    detailACTotal: (n: number) => `Total: ${n} MD`,
    detailProgressCurrent: 'Current % completion:',
    timesheetTeamPlaceholder: '— Team * —',
    timesheetNotePlaceholder: 'Note (optional)',
    timesheetAddBtn: '+ Add Entry',
    timesheetProgressError: (pct: number) => `Current % completion: **${pct}%** — new % cannot be lower.`,
    validationTeam: 'Select a team.',
    validationProgress: 'Fill in % progress.',
    validationProgressRange: '% must be between 0–100.',
    excelHeaders: ['WBS', 'Title', 'Type', 'Start (day)', 'Duration (days)', 'Critical', 'Status', 'Assigned To'] as string[],
    excelYes: 'Yes',
    excelNo: 'No',
    excelExporting: '⏳ Exporting...',
    excelBtnLabel: '⬇ Excel',
    excelTitlePrefix: 'Project Schedule (Gantt Chart)',
    excelSubtitle: (start: string, days: number, weeks: number, phasesN: number, activitiesN: number, milestonesN: number) =>
      `Start date: ${start} · Total duration: ${days} days (~${weeks} wks) · ${phasesN} phases · ${activitiesN} activities · ${milestonesN} milestones`,
    excelMonthLabel: (n: number) => `Month ${n}`,
    excelColNum: '#',
    excelColTask: 'Task / Deliverable',
    excelColOwner: 'Owner',
    excelColType: 'Type',
    excelColStart: 'Start\n(Date)',
    excelColDuration: 'Duration\n(days)',
    excelColEnd: 'End\n(Date)',
    excelColDep: 'Dependency / Comment',
    excelTypeActivity: 'Task',
    excelTypeMilestone: 'Milestone',
    excelTypeClientDep: 'Prerequisite',
    excelDepAfter: 'After:',
    excelNoOwner: '—',
    excelLegendTitle: 'Legend:',
    excelLegendActivity: 'Task',
    excelLegendCompleted: 'Completed',
    excelLegendClientDep: 'Client Dependency',
    excelLegendCritical: 'Critical Path / Delayed',
    excelLegendMilestone: 'Milestone',
    excelFootnote: 'This Gantt chart was generated automatically from eazyproject data at export time. Weekly columns start from the project\'s start date.',
    listHeaders: ['WBS', 'Title', 'Type', 'Start', 'Duration', 'Status', 'Assigned To'] as string[],
    daysAbbr: 'd.',
    labelDays: 'days',
    labelStartDay: 'Start Day',
    labelEndDay: 'End Day',
    labelDuration: 'Duration',
    aiScheduleTitle: 'Analyze Project Charter & Specs and auto-generate schedule',
  },

  workingCalendar: {
    dropdownTitle: 'PROJECT CALENDAR',
    dropdownEdit: 'Edit calendar →',
    kpiWorkingDays: (wd: number, cd: number) => `${wd} Working days · ${cd} calendar days`,
    toastSwitched: (name: string, date: string) => `Project calendar: ${name} · finish ${date}`,
    toastSaved: 'Working time saved',
    toastSavedRescheduled: (date: string) => `Saved. Rescheduled · new finish ${date}`,
    legendNonWorking: 'Non-working',
    legendHoliday: 'Holiday',
    legendException: 'Exception',
    calendarDaysSuffix: 'calendar days',

    baseStandard: 'Standard',
    base24h: '24 Hours',
    baseNightShift: 'Night Shift',
    tagBase: 'Base',
    tagProject: 'Project',
    isProjectCalendar: 'Project calendar',
    noWorkingDays: 'No working days',

    modalTitle: 'Working time',
    modalSubtitle: (project: string, cal: string) => `${project} · Project calendar: ${cal}`,
    calendarsTitle: 'Calendars',
    newCalendar: '+ New calendar',
    newProjectNote: "New projects start with Standard and the project's country holidays.",
    setAsProject: 'Set as project calendar',
    delete: 'Delete',
    tabCalendar: 'Calendar',
    tabWeek: 'Work week',
    tabExceptions: 'Exceptions & holidays',
    tabSettings: 'Settings',
    cancel: 'Cancel',
    save: 'Save',
    saveReschedule: 'Save & reschedule',
    saveSetAsProject: 'Save & set as project',
    unsavedChanges: '● Unsaved changes',
    noChanges: 'No changes',
    close: 'Close',

    weekQuick: 'Quick setup:',
    presetMonFri: 'Mon–Fri',
    presetMonSat: 'Mon–Sat',
    presetAll: 'All days',
    presetStandard: 'Standard 09–18',
    weekDay: 'Day',
    weekHours: 'Hours',
    weekTotal: (h: number) => `${h}h / week`,
    addRange: '+ Time range',
    nonWorkingDay: 'Non-working',
    from: 'From',
    to: 'To',

    holidaysTitle: 'Project holidays',
    holidaysActive: (on: number, total: number) => `${on} of ${total} active`,
    allOn: 'All on',
    allOff: 'All off',
    fetchingHolidays: 'AI is fetching holidays…',
    fetchHolidaysError: "Couldn't fetch holidays. Try again.",
    noHolidaysYet: 'No holidays set yet. Set a country in the Settings tab and click Calculate holidays.',
    exceptionsTitle: (n: number) => `Exceptions · ${n}`,
    newException: '+ New exception',
    noExceptions: 'No exceptions yet.',
    colName: 'Name', colDates: 'Dates', colType: 'Type', colRepeat: 'Repeat',
    repeatOnce: 'Once', repeatWeekly: 'Weekly', repeatYearly: 'Yearly',
    typeOff: 'Non-working', typeWork: 'Working',

    hoursPerDay: 'Hours per day',
    hoursPerWeek: 'Hours per week',
    weekStarts: 'Week starts on',
    holidayCountry: 'Holiday country',
    noCountrySet: 'No country set',
    change: 'Change',

    impactTitle: 'Impact on project',
    impactFinish: 'Project finish',
    impactNoChange: 'no change',
    impactDays: (sign: string, n: number) => `${sign}${n} d`,
    impactMoved: (n: number) => `${n} activities moved`,
    notProjectCalendar: (name: string) => `You're editing "${name}", which isn't the project calendar. Its changes don't affect the schedule.`,
    willBecomeProjectCalendar: "This will be set as the project's calendar on save — the schedule will be rescheduled.",

    dlgExcTitle: 'New exception',
    dlgExcName: 'Name', dlgExcNamePh: 'e.g. Team training',
    dlgExcFrom: 'From', dlgExcTo: 'To', dlgExcType: 'Type',
    dlgExcTypeOff: 'Non-working', dlgExcTypeOffSub: 'Holiday, leave, closure',
    dlgExcTypeWork: 'Working / custom hours', dlgExcTypeWorkSub: 'e.g. Saturday 08–14',
    dlgExcRepeat: 'Repeat', dlgExcAdd: 'Add',

    dlgNewTitle: 'New calendar',
    dlgNewName: 'Name',
    dlgNewStartFrom: 'Start from',
    dlgNewCopy: 'Copy of existing', dlgNewCopySub: 'Keeps hours & exceptions',
    dlgNewBlank: 'Blank', dlgNewBlankSub: 'Mon–Fri 09–17, no exceptions',
    dlgNewAiHolidays: '✦ AI holidays',
    dlgNewUseForProject: (project: string) => `Set as calendar for project ${project}`,
    dlgNewCreate: 'Create',

    dlgDelTitle: (name: string) => `Delete "${name}"?`,
    dlgDelBody: 'Its work week, exceptions and holidays will be deleted. This takes effect when you save.',
    dlgDelInUse: 'The project uses this calendar. Choose a replacement:',
    dlgDelConfirm: 'Delete',
    cantDeleteActiveCalendar: "This is the project's calendar — set a different one first to delete it",

    dlgCountryTitle: 'Holiday country',
    dlgCountryCountry: 'Country',
    dlgCountryCity: 'City (optional)',
    dlgCountrySubmit: 'Calculate holidays',
    dlgCountryTryAgain: 'Try again',
  },

  budget: {
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as string[],
    tabDashboard: '📊 Dashboard',
    tabHR: '👥 Human Resources',
    tabVendors: '🤝 External Vendors',
    tabBilling: '🧾 Client Billing',
    dashTitle: 'Key Variables',
    dashPerformance: 'Performance Indicators',
    dashForecasts: 'Completion Forecasts',
    dashRemainingCost: 'Remaining cost',
    dashCostToDate: 'Cost to date',
    dashCostToday: 'Cost today',
    statusOnBudget: 'On budget',
    statusOnCost: 'On cost ✓',
    statusUnderBudget: 'Under budget',
    statusOverCost: 'Cost overrun ⚠',
    statusOverPct: 'Overrun %',
    statusNeedsImprovement: 'Needs improvement ⚠',
    statusNonStdDeviation: 'Non-standard deviations',
    statusOnSchedule: 'On schedule ✓',
    statusScheduleDelay: 'Schedule delay ⚠',
    statusDelayPct: 'Delay %',
    statusExpectedDate: 'Exp. Date',
    statusActualDate: 'Act. Date',
    statusActualDateFull: 'Actual Date',
    statusPlannedDate: 'Planned Date',
    labelDate: 'Date',
    totalContracts: 'Total Contracts',
    totalContract: 'Total Contract',
    totalHRBudget: 'Total HR Budget',
    hrEnterMD: 'Enter MD per team in Scope',
    hrNoEntries: 'No entries recorded',
    hrNoConsumption: 'No consumption',
    hrFromActivities: 'From activity costs',
    hrEmptyHint: 'Start from the "Human Resources" or "External Vendors" tab.',
    teamNewBtn: 'New Work Team',
    teamEditTitle: 'Edit Team',
    teamDeleteTitle: 'Delete Team',
    vendorNewBtn: 'New External Vendor',
    vendorEditTitle: 'Edit Vendor',
    vendorDeleteTitle: 'Delete Vendor',
    invoiceNewTitle: (name: string) => `New Invoice — ${name}`,
    invoiceEditTitle: 'Edit Invoice',
    invoiceDeleteTitle: 'Delete Invoice',
    invoiceRecordBtn: 'Record invoice',
    invoiceMarkOverdueBtn: 'Mark as overdue',
    billingNewBtn: 'New Billing Installment',
    billingEditTitle: 'Edit Installment',
    billingDeleteTitle: 'Delete Installment',
    statusPending: 'Pending',
    statusPendingSingle: 'Pending',
    statusInProgress: 'In Progress',
    statusOverdue: 'Overdue',
    statusReceived: 'Received',
    statusInvoiced: 'Invoiced',
    fieldNote: 'Note',
    fieldAmount: 'Amount',
    fieldCondition: 'Condition',
    fieldAddToSchedule: 'Add to schedule',
    fieldOptionalNote: 'Optional note...',
    placeholderTeamName: 'e.g. Development Team',
    placeholderTeamRole: 'e.g. Senior Developers',
    placeholderBudgetCost: 'e.g. 50000',
    placeholderBudgetMD: 'e.g. 80',
    placeholderVendorName: 'e.g. ABC Consulting',
    placeholderVendorRole: 'e.g. Technical Consultant',
    placeholderContractAmount: 'e.g. 20000',
    placeholderInvoiceAmount1: 'e.g. 32000',
    placeholderInvoiceAmount2: 'e.g. 15000',
    placeholderMilestone1: 'e.g. 1st installment — Contract signing',
    placeholderMilestone2: 'e.g. Deliverable A submission and client approval',
    placeholderMilestone3: 'e.g. Deliverable 2 — Development completion',
    errorNoContract: 'No contract found. Please upload the contract first when creating the project.',
    errorAINoSchedule: 'The AI did not identify a billing schedule with sufficient confidence in the contract.',
    errorAI: 'AI error. Please try again.',
    errorAnalysis: 'Analysis error. Please try again.',
    errorInvalidResponse: 'Invalid response',
    needsAC: 'Needs AC',
    needsPV: 'Needs PV',
    needsStartDate: 'Needs start date',
    unallocated: 'Unallocated',
    easyCompletion: 'Easy completion ✓',
    expectedOverrun: 'Expected overrun',
    costMargin: 'Cost margin',
    excelHeaders: ['Title', 'Role', 'Budget MD', 'Budget Cost', 'Consumed MD', 'Consumed Cost', 'Remaining MD'] as string[],
    excelVendorHeaders: ['Vendor', 'Role', 'Contract', 'Paid', 'Pending', 'Overdue'] as string[],
    excelBillingHeaders: ['Description', 'Amount', 'Condition', 'Planned Date', 'Status', 'Actual Date', 'Actual Amount'] as string[],
  },

  risk: {
    categories: ['Schedule', 'Financial', 'Technical', 'Legal/Contractual', 'Organizational', 'External'] as string[],
    scoreHigh: 'High',
    scoreMedium: 'Medium',
    scoreLow: 'Low',
    matrixImpactAxis: 'Impact',
    matrixProbabilityAxis: 'Probability',
    matrixImpactHigh: 'High',
    matrixImpactMedium: 'Medium',
    matrixImpactLow: 'Low',
    matrixProbHigh: 'High',
    matrixProbMedium: 'Medium',
    matrixProbLow: 'Low',
    legendLow: 'Low (0-3.9)',
    legendMedium: 'Medium (4-6.9)',
    legendHigh: 'High (7-10)',
    tableHeaders: ['Title', 'Prob. (0-1)', 'Impact (0-10)', 'Score', 'Risk Owner', 'Status', 'Actions'] as string[],
    emptyState: 'No risks yet.',
    aiBannerTitle: 'Updates from AI Re-analysis',
    aiNewRisks: (n: number) => `+${n} new risks`,
    aiSuggestions: (n: number) => `${n} re-evaluation suggestions`,
    aiSuggestionTitle: '✦ AI Suggestion based on new document',
    aiSuggestionNewProb: 'New Probability',
    aiSuggestionNewImpact: 'New Impact',
    aiSuggestionReason: 'Reason for change',
    aiSuggestionNewMitigation: 'New Mitigation Suggestion',
    aiAcceptBtn: '✓ Accept',
    aiRejectBtn: '✕ Reject',
    newBadge: '● New',
    newBadgeHint: 'Click to confirm',
    modalEditTitle: 'Edit Risk',
    modalNewTitle: 'New Risk',
    fieldTitle: 'Title *',
    fieldTitlePlaceholder: 'e.g. Delivery delay',
    fieldDescription: 'Description',
    fieldDescriptionPlaceholder: 'Risk description...',
    fieldProbability: (v: number) => `Probability (0-1): **${v}**`,
    fieldImpact: (v: number) => `Impact (0-10): **${v}**`,
    fieldScorePreview: (score: number, label: string) => `Score: ${score} — ${label}`,
    fieldOwner: 'Risk Owner',
    fieldOwnerPlaceholder: '— Select owner —',
    fieldOwnerNoStakeholders: 'No stakeholders — add them first in the Stakeholder Register',
    fieldMitigation: 'Mitigation Measures',
    fieldMitigationPlaceholder: 'How the risk will be mitigated...',
    fieldMitigationAI: '🤖 AI Suggestion',
    fieldStatus: 'Status',
    fieldComments: 'Comments',
    btnAddRisk: '+ New Risk',
    btnEditShort: 'Edit',
    btnDeleteShort: 'Del.',
    excelHeaders: ['Title', 'Description', 'Probability (0-1)', 'Impact (0-10)', 'Score', 'Level', 'Risk Owner', 'Mitigation Measures', 'Status'] as string[],
  },

  issues: {
    cardOpen: 'Open',
    cardInProgress: 'In Progress',
    cardResolved: 'Resolved',
    cardTotal: 'Total',
    sectionHighPriority: '🚨 High Priority',
    sectionByCategory: '📊 By Category',
    sectionByStatus: '📈 By Status',
    emptyHighPriority: 'No open critical or high issues!',
    emptyIssues: 'No issues yet.',
    emptyIssuesSubtext: 'Issues are recorded by the team when problems arise.',
    tableHeaders: ['Title', 'Category', 'Priority', 'Status', 'Owner', 'Deadline', 'Impact', 'Actions'] as string[],
    modalEditTitle: 'Edit Issue',
    modalNewTitle: 'New Issue',
    fieldTitle: 'Title *',
    fieldTitlePlaceholder: 'e.g. Backend module delivery delay',
    fieldDescription: 'Description',
    fieldDescriptionPlaceholder: 'Detailed description of the problem...',
    fieldCategory: 'Category',
    fieldPriority: 'Priority',
    fieldStatus: 'Status',
    fieldOwner: 'Issue Owner',
    fieldOwnerPlaceholder: '— Select owner —',
    fieldOwnerNoStakeholders: 'No stakeholders — add them first in the Stakeholder Register',
    fieldDateIdentified: 'Date Identified',
    fieldDeadline: 'Resolution Deadline',
    fieldImpact: 'Project Impact',
    fieldActionPlan: 'Action Plan',
    fieldActionPlanPlaceholder: 'What actions are being taken to resolve...',
    fieldActionPlanAI: '🤖 AI Suggestion',
    fieldRiskRef: 'Link to Risk (optional)',
    fieldRiskRefPlaceholder: 'e.g. R-001 Development delay',
    btnAddIssue: '+ New Issue',
    excelHeaders: ['Title', 'Description', 'Category', 'Priority', 'Status', 'Owner', 'Date Identified', 'Deadline', 'Impact', 'Action Plan'] as string[],
  },

  stakeholders: {
    matrixInfluenceAxis: 'Influence →',
    matrixInterestAxis: 'Interest →',
    quadrantManageClosely: 'High influence & interest',
    quadrantKeepSatisfied: 'High influence, low interest',
    quadrantKeepInformed: 'Low influence, high interest',
    quadrantMonitor: 'Low influence & interest',
    cardInfluence: 'Influence',
    cardInterest: 'Interest',
    cardStrategy: 'Strategy:',
    emptyState: 'No stakeholders yet.',
    emptySubtext: 'Click "+ New Stakeholder" to create',
    modalEditTitle: 'Edit Stakeholder',
    modalNewTitle: 'New Stakeholder',
    modalSyncNote: 'Changes to Name, Role, Organization and Email will be automatically updated in the Organization Chart',
    fieldName: 'Name *',
    fieldNamePlaceholder: 'e.g. John Smith',
    fieldTeam: 'Team',
    fieldTeamNone: '— No team —',
    fieldRole: 'Role',
    fieldRolePlaceholder: 'e.g. Project Sponsor',
    fieldOrganization: 'Organization',
    fieldOrganizationPlaceholder: 'e.g. Construction Ltd.',
    fieldInfluence: (v: number) => `Influence (0-5): **${v}**`,
    fieldInterest: (v: number) => `Interest (0-5): **${v}**`,
    fieldQuadrant: (label: string) => `Quadrant: **${label}**`,
    fieldEngagement: 'Engagement Level',
    fieldStrategy: 'Management Strategy',
    fieldStrategyPlaceholder: 'How will you manage this stakeholder...',
    btnAdd: '+ New Stakeholder',
    excelHeaders: ['Name', 'Role', 'Organization', 'Contact', 'Influence (0-5)', 'Interest (0-5)', 'Engagement', 'Quadrant', 'Strategy'] as string[],
  },

  dailyLog: {
    subtitle: 'Task tracking and daily progress',
    btnNew: '+ New entry',
    filterAllAssignees: '👤 All assignees',
    filterAllStatuses: '📋 All statuses',
    filterClear: '✕ Clear',
    noAssignee: 'Unassigned',
    commentsLabel: 'comments',
    dragHere: 'Drop here',
    confirmDeleteTask: 'Delete task?',
    modalNewTitle: 'New entry',
    modalEditTitle: 'Edit task',
    btnEdit: '✎ Edit',
    btnCreate: 'Create',
    createdBy: 'Created',
    fieldAssignee: 'Assignee',
    fieldAssigneePlaceholder: '— Select assignee —',
    fieldStatus: 'Status',
    fieldCompletionDate: 'Completion Date',
    fieldDeadline: 'Deadline',
    fieldDescription: 'Description',
    fieldAttachments: '📎 Attachments',
    uploadBtn: '+ Upload',
    uploadingBtn: 'Uploading...',
    noAttachments: 'No attachments.',
    deleteFileTitle: 'Delete file',
    deleteFileText: 'This action cannot be undone',
    deleteFileLabel: 'File',
    fieldComments: '💬 Comments',
    noComments: 'No comments yet.',
    commentPlaceholder: 'Write a comment...',
    commentAdd: '+ Add',
    fieldTitle: 'Title *',
    fieldTitlePlaceholder: 'e.g. Review Phase A deliverables',
    fieldDescPlaceholder: 'Detailed description...',
    fieldWorkPackage: 'Parent Work Package',
    fieldWorkPackagePlaceholder: 'e.g. WP1: Analysis',
    fieldActivity: 'Activity (from Schedule)',
    fieldActivityPlaceholder: '— Select activity —',
    fieldCreationDate: 'Creation Date',
    daysToday: 'Today!',
    daysAbbr: 'd.',
    overdueMsg: (days: number) => `Overdue — ${days} days`,
    dueTodayMsg: 'Due today!',
    daysLeftMsg: (days: number) => `${days} days left`,
    dateLocale: 'en-US',
    fieldCritical: 'Critical',
    fieldCriticalDesc: 'Important / Critical',
    filterAllCritical: 'All tasks',
    filterCriticalOnly: 'Critical only',
    filterNonCriticalOnly: 'Non-critical',
  },

  orgChart: {
    tabTeam: 'Project Team',
    tabPairs: 'Who talks to whom',
    aiGeneratedLabel: 'From contract analysis',
    btnCollapseAll: 'Collapse all',
    btnExpandAll: 'Expand all',
    btnAddMember: '+ Add member',
    btnAddAbovePM: 'Add above PM',
    emptyMembers: 'No members yet.',
    membersBadge: (n: number) => `${n} members`,
    btnDefinePair: '+ Define Contact',
    btnDefinePairSmall: '+ Define contact',
    noClientContact: 'No client contact',
    emptyPairs: 'Add team members first.',
    modalEditMember: 'Edit Member',
    modalNewSubordinate: 'New Subordinate',
    modalNewMember: 'New Team Member',
    subordinateOf: 'Subordinate of:',
    fieldName: 'Name *',
    fieldFromStakeholder: '— Select from Stakeholder Register —',
    stakeholderAutoFilled: '✦ Fields auto-filled from Stakeholder Register',
    fieldTeam: 'Team',
    fieldTeamPlaceholder: 'e.g. Engineers',
    fieldEditFromStakeholder: 'Edit only from Stakeholder Register',
    fieldRole: 'Role *',
    fieldRolePlaceholder: 'e.g. Project Engineer',
    fieldOrganization: 'Company / Organization',
    fieldOrganizationPlaceholder: 'e.g. Construction Ltd.',
    fieldActivities: 'Assigned Activities from WBS',
    activitiesEmpty: 'No assigned activities yet.',
    stakeholderRequired: 'Select a member from the Stakeholder Register to continue.',
    modalPairTitle: 'Define Client Contact',
    pairForMember: 'For which team member?',
    pairMemberPlaceholder: '-- Select member --',
    pairClientName: 'Client contact name *',
    pairClientNamePlaceholder: 'e.g. John Smith',
    pairRole: 'Role',
    pairRolePlaceholder: 'e.g. Project Owner',
    pairCompany: 'Company',
    pairCompanyPlaceholder: 'Client company',
    pairChannels: 'Communication Channels',
    pairFrequency: 'Frequency',
    pairType: 'Type',
    pairNote: 'Note',
    pairNotePlaceholder: 'Optional note...',
    channels: ['Email', 'Phone', 'Teams/Zoom', 'Slack', 'In-person'] as string[],
    frequencies: ['Daily', 'Weekly', 'Biweekly', 'Monthly', 'As needed'] as string[],
    types: ['Regular', 'Ad-hoc', 'Report', 'Approval'] as string[],
    defaultFrequency: 'Weekly',
    defaultType: 'Regular',
    statusCompleted: 'Completed',
    statusInProgress: 'In Progress',
    statusDelayed: 'Delayed',
    statusNotStarted: 'Not Started',
  },

  aiAdvisor: {
    subtitle: 'Suggestions based on transcripts and emails — accept or dismiss each action',
    pendingBadge: (n: number) => `${n} pending suggestions`,
    filterPending: 'Pending',
    filterAll: 'All',
    filterAccepted: 'Accepted',
    filterRejected: 'Rejected',
    emptyPendingTitle: 'No pending suggestions',
    emptyTitle: 'No suggestions',
    emptyPendingDesc: 'No pending suggestions — new insights are generated automatically from transcripts and emails',
    emptyFilterDesc: 'No insights for this filter',
    acceptAll: '✓ Accept all',
    dismiss: 'Dismiss',
    statusAccepted: '✓ Accepted',
    statusRejected: '✕ Rejected',
    suggestedActions: 'Suggested Actions',
    probLabel: 'Prob',
    impactLabel: 'Impact',
    actionDone: '✓ Done',
    actionRejected: '✕ Rejected',
    timeJustNow: 'just now',
    timeMinutes: (m: number) => `${m}m ago`,
    timeHours: (h: number) => `${h}h ago`,
    actionLabels: {
      add_risk: '⚠️ Add Risk',
      update_risk: '✏️ Update Risk',
      add_issue: '🔧 Create Issue',
      update_schedule: '📅 Schedule Note',
    } as Record<string, string>,
  },

  lessonsLearned: {
    addLesson: '+ New Lesson',
    emptyTitle: 'No lessons recorded yet.',
    emptyDesc: 'Lessons learned are recorded during project archiving or you can add a new one at any time.',
    addFirstLesson: '+ Add Lesson',
    labelWentWell: '✅ What went well',
    labelWentWrong: '❌ What went wrong',
    labelKeyLessons: '💡 Key Lessons',
    labelRisksRealized: '⚠️ Risks that materialized',
    labelSuggestions: 'Suggestions:',
    modalTitle: '📝 New Lesson Learned',
    fieldType: 'Project Type',
    fieldTypePlaceholder: 'e.g. SaaS Development, Construction...',
    fieldRating: 'Overall Rating:',
    ratingBad: '1 ⭐ Poor',
    ratingMedium: '3 ⭐ Average',
    ratingExcellent: '5 ⭐ Excellent',
    fieldWentWell: '✅ What went well?',
    fieldWentWellPlaceholder: 'Which practices worked well...',
    fieldWentWrong: '❌ What went wrong?',
    fieldWentWrongPlaceholder: 'Which problems arose...',
    fieldKeyLessons: '💡 Key Lessons',
    lessonPlaceholder: (i: number) => `Lesson ${i + 1}...`,
    fieldRisks: '⚠️ Risks that materialized',
    riskPlaceholder: (i: number) => `Risk ${i + 1}...`,
    fieldScheduleDelays: '📅 Schedule Delays',
    scheduleDelaysPlaceholder: 'e.g. +2 months due to...',
    fieldBudgetVariance: '💰 Budget Variance',
    budgetVariancePlaceholder: 'e.g. +15% due to...',
    fieldSuggestions: '🔮 Suggestions for future projects',
    suggestionsPlaceholder: 'What would you do differently...',
  },

  projectSpecs: {
    sectionBasic: 'Basic Information',
    fieldProjectName: 'Project Name',
    fieldDescription: 'Description',
    fieldStatus: 'Status',
    fieldStatusActive: '● Active',
    fieldCreatedAt: 'Created At',
    fieldProjectId: 'Project ID',
    sectionAI: 'AI Status',
    fieldAIAnalysis: 'AI Analysis',
    fieldAIDone: '✓ Completed',
    fieldAINotRun: '✕ Not run yet',
    fieldTranscripts: (n: number) => `${n} uploaded`,
    fieldPendingInsights: 'Pending AI Suggestions',
    fieldPendingCount: (n: number) => `${n} pending`,
    fieldPendingNone: '✓ None pending',
    sectionEmail: 'Email Integration',
    gmailNotConnected: 'Gmail not connected',
    gmailConnectWarning: 'Connection required to enable email integration',
    gmailConnect: '🔗 Connect Gmail',
    gmailConnected: 'Gmail connected',
    gmailPolling: '● Polling active',
    gmailDisconnect: 'Disconnect',
    gmailDisconnectConfirm: 'Disconnect Gmail from this project?',
    emailLabel: 'Email Integration for this project',
    emailHint: 'Add the project email as CC in your correspondence',
    emailToggleTip: 'Add a project email first',
    emailProjectLabel: 'Project Email (provided by IT)',
    emailPlaceholder: 'e.g. project_abc@company.com',
    emailSave: 'Save',
    emailCopied: '✓ Copied',
    emailCopy: '📋 Copy',
    emailAnalysisNote: '✓ Every email you receive with this CC will be automatically analyzed by AI',
    sectionSources: 'AI Data Sources',
    sources: [
      { icon: '📄', label: 'Contract / RFO', desc: 'Initial analysis at project creation' },
      { icon: '📁', label: 'Other Documents', desc: 'Automatic re-analysis on each upload' },
      { icon: '🎙️', label: 'Meeting Transcripts', desc: 'Analysis of each new transcript' },
      { icon: '📋', label: 'Task Tracker Tasks', desc: 'Kanban tasks as project knowledge' },
      { icon: '📧', label: 'Email Correspondence', desc: 'Incoming email analysis' },
    ] as { icon: string; label: string; desc: string }[],
  },

  transcript: {
    pageTitle: 'Meeting Transcripts',
    subtitle: 'Upload transcripts — AI analyzes and automatically updates modules',
    newTranscript: '+ New Transcript',
    emptyTitle: 'No transcripts yet',
    aiProcessed: '✦ AI Analyzed',
    aiProcessing: '⏳ Processing',
    aiProcessingLong: '⏳ Processing by AI...',
    noContent: 'No content available',
    aiNote: '✦ AI analyzed this transcript — see suggestions in AI Advisor',
    selectHint: 'Select a transcript to view its content',
    uploadModalTitle: 'New Transcript',
    fieldTitle: 'Meeting Title *',
    fieldTitlePlaceholder: 'e.g. Kick-off Meeting with client',
    fieldDate: 'Meeting Date',
    fieldMeeting: 'Link to a meeting (optional)',
    fieldMeetingNone: '— None —',
    fieldFile: 'Transcript File *',
    dropHint: 'Drag file or click to select',
    aiUploadNote: '✦ AI will automatically analyze the transcript and create suggestions in AI Advisor',
    uploading: '⏳ Uploading...',
    uploadBtn: 'Upload',
    deleteTitle: 'Delete Transcript',
    deleteSubtitle: 'This action cannot be undone',
    deleteConfirm: 'Delete',
    timeJustNow: 'just now',
    timeMinutes: (m: number) => `${m}m ago`,
    timeHours: (h: number) => `${h}h ago`,
  },

  meetings: {
    title: 'Meetings',
    newMeeting: '+ New Meeting',
    empty: 'No meetings yet.',
    backToList: 'Back to meetings',
    participants: 'Participants',
    agenda: 'Agenda',
    generate: '✦ Generate Agenda',
    regenerate: '✦ Regenerate Agenda',
    generating: '⏳ Generating...',
    noAgenda: 'No agenda generated yet. Click "Generate Agenda" to let the AI propose topics based on the project\'s open items and the participants.',
    genDone: 'The AI proposed {n} topic(s) for this meeting.',
    genNoOpenItems: 'There are no open Issues / Risks / Tasks in this project — nothing to build an agenda from yet.',
    genNoMatch: 'Checked {n} open items, but the AI found none relevant to the participants. Add topics manually or change the participants.',
    genNoParticipants: 'No participants set — only the {n} most critical items were added automatically. Set participants for a targeted agenda.',
    genCapped: '(+{n} more items in "Other open items" below.)',
    genError: 'Agenda generation failed.',
    participantScope: 'Teams / organizations',
    otherOpen: 'Other open items',
    transcriptLabel: 'Transcript',
    transcriptLinked: 'Linked',
    pickTranscript: '-- Pick a transcript --',
    processing: 'processing',
    noTranscripts: 'No transcripts in this project. Upload them from the Transcripts module.',
    link: 'Link',
    unlink: 'Unlink',
    lastMatch: 'Last match',
    completeBtn: '✓ Complete meeting',
    completeTitle: 'Complete meeting',
    completeHint: 'The current agenda is frozen as a snapshot and the meeting moves to "Held". You can then run the transcript match.',
    completeConfirm: 'Complete',
    matchBtn: '✦ Match with transcript',
    rematchBtn: '✦ Re-run match',
    matching: '⏳ Matching...',
    matchNeedsTranscript: 'Link a transcript first',
    matchDone: 'Match complete — see the per-topic results.',
    matchError: 'Transcript match failed.',
    completedMsg: 'Meeting completed. Link/upload a transcript and run the match.',
    outcome: {
      discussed_resolved: 'Resolved',
      decision_made: 'Decision',
      discussed_open: 'Still open',
      not_discussed: 'Not discussed',
    } as Record<string, string>,
    proposalTitle: 'Suggested update',
    proposalStatus: 'New status',
    proposalNote: 'Note',
    applyBtn: 'Apply',
    dismissBtn: 'Dismiss',
    applied: 'Applied',
    newActionsTitle: 'New action items from the meeting',
    createTaskBtn: '+ Create task',
    generalNotesTitle: 'General notes (off-agenda)',
    createBtn: 'Create',
    noDate: 'No date',
    today: 'Today',
    addTopic: '+ Add topic',
    addAdhoc: 'Free topic',
    addLinked: 'From open items',
    topicPh: 'Topic description...',
    pickItem: '-- Pick an item --',
    noteTalkingPoint: 'Talking point',
    noteDecision: 'Decision',
    notesPh: 'Notes / talking points for this topic...',
    fieldTitle: 'Title',
    fieldType: 'Type',
    fieldTypePh: 'e.g. weekly sync, steering committee, ad-hoc',
    fieldDate: 'Date',
    fieldParticipants: 'Participants (from the Stakeholder Register)',
    noStakeholders: 'No stakeholders — add them first in the Stakeholders module.',
    confirmDelete: 'Delete meeting',
    status: {
      draft: 'Draft',
      agenda_ready: 'Agenda ready',
      held: 'Held',
      closed: 'Closed',
    } as Record<string, string>,
    category: {
      decision_needed: 'Needs a decision from them',
      blocked_on_them: 'Blocked — waiting on them',
      update_for_them: 'Update for them',
      risk_to_flag: 'Risk to flag',
      other: 'Other',
    } as Record<string, string>,
  },

  scope: {
    statusLabels: {
      completed: 'Completed',
      in_progress: 'In Progress',
      delayed: 'Delayed',
      not_started: 'Not Started',
    } as Record<string, string>,
    aiBadge: '✦ AI-generated · From contract analysis',
    statUnassigned: 'Unassigned',
    statCompletion: 'Completion',
    hintDragWP: '⠿ Drag <strong>Work Packages</strong> to reorder',
    hintDragActivity: '⠿ Drag <strong>Activity</strong> within WP to reorder or to another WP to move',
    hintDetails: '⋯ Click for details / Implementation Estimate',
    emptyTitle: 'No Work Packages yet',
    emptyDescEdit: 'Create Work Packages manually or let AI analyze the contract.',
    emptyDescView: 'No Work Packages for this project.',
    aiConfirmTitle: 'AI Generate WBS',
    aiConfirmSubtitle: 'Automatic analysis from the contract',
    aiConfirmWarning: 'AI will automatically create Work Packages from the contract. Any existing Work Packages will be replaced.',
    deleteWPTitle: 'Delete Work Package',
    deleteWPSubtitle: 'This action cannot be undone',
    deleteWPActivitiesSingle: 'The 1 assigned activity will become unassigned and will not be lost.',
    deleteWPActivitiesMultiple: (n: number) => `The ${n} assigned activities will become unassigned and will not be lost.`,
    modalEditWP: 'Edit Work Package',
    modalNewWP: 'New Work Package',
    titleLabel: 'Title *',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Brief description...',
    mdLabel: 'Implementation Estimate in Man-Days (MD)',
    assignHint: 'Select activities. Activities already assigned to other WPs are not shown.',
    assignedSectionTitle: (n: number) => `✅ Assigned (${n})`,
    availableSectionTitle: (n: number) => `📋 Available (${n})`,
    allAssigned: 'All activities have been assigned.',
    actDetailTitle: 'Activity Details',
    actNameLabel: 'Name',
    actNameHint: '📌 Managed from Schedule',
    actDescLabel: 'Description',
    actDescEmpty: 'No description',
    actAssigneeLabel: 'Assign to team members',
    actAssigneeEmpty: 'Not assigned',
    actMDLabel: 'MD per Team',
    actNoTeams: 'No teams in Budget → Human Resources.',
    actTotal: (md: number) => `Total: ${md} MD`,
    actWBSLabel: 'WBS Code',
    actStatusLabel: 'Status',
    dragHandleTip: 'Drag to reorder WP',
    actDragHandleTip: 'Drag',
    dropZoneHint: 'Drop here',
    assignBtn: '+ Assign Activities',
    availablePanel: (n: number) => `📋 Unassigned Activities (${n})`,
    availablePanelHint: ' — Not assigned to any Work Package',
    errorGenerate: 'Error during generation. Please try again.',
    btnBack: 'Back',
    btnContinue: 'Continue',
    btnClose: 'Close',
    btnAssign: '+ Assign',
  },

  documents: {
    pageTitle: 'Management Documents',
    tabDeliverables: 'Contract Deliverables',
    tabOther: 'Other Documents',
    deliverablesTitle: 'Contract Deliverables',
    deliverablesSubtitle: 'Chapters, subchapters and AI fill',
    newDeliverable: '+ New Deliverable',
    emptyDelTitle: 'No deliverables yet',
    emptyDelDesc: 'Create the first deliverable with chapters and subchapters.',
    createDeliverable: '+ Create Deliverable',
    chaptersLabel: (n: number) => `${n} chapters`,
    deleteLabel: '🗑 Delete',
    deleteDeliverableTitle: 'Delete Deliverable',
    deleteDocTitle: 'Delete Document',
    deleteSubtitle: (title: string) => `"${title}" — this action cannot be undone`,
    deleteConfirmLabelPre: 'Type',
    deleteConfirmLabelPost: 'to confirm',
    statusDefault: 'Pending',
    modalNewDel: 'New Deliverable',
    modalEditDel: 'Edit Deliverable',
    fieldTitle: 'TITLE *',
    fieldTitlePlaceholder: 'e.g. Technical Report Phase 1',
    fieldDescription: 'DESCRIPTION',
    fieldCategory: 'CATEGORY',
    fieldDeadline: 'DEADLINE',
    fieldStatus: 'STATUS',
    statusOptions: ['Pending', 'In Progress', 'Completed'] as string[],
    fieldChapters: 'CHAPTERS',
    chapterPlaceholder: 'Chapter title...',
    addChapter: '+ Add',
    createBtn: 'Create',
    deleteConfirmWord: 'Delete',
    deletePlaceholder: 'Delete',
    backBtn: '← Back',
    editBtn: '✎ Edit',
    noChapters: 'No chapters.',
    addChapterLink: '+ Add chapter',
    addSubChapter: '+ subchapter',
    newChapterBtn: '+ New chapter',
    renameTip: 'Double-click to rename',
    fillWithAITitle: 'Fill chapter with AI',
    fillSubWithAITitle: 'Fill subchapter with AI',
    downloadDocx: '⬇ Download .docx',
    fillActiveBtn: '⟳ Editing...',
    fillBtn: '✦ Fill with AI',
    aiFillingNote: '✦ AI is analyzing project documents and writing the content...',
    selectChapter: 'Select a chapter or subchapter from the left',
    addDocument: 'Add Document',
    addDocumentHint: 'PDF & DOCX are automatically analyzed by AI',
    categoryLabel: 'Category',
    uploadHint: 'Drag or select file',
    uploadingHint: 'Uploading & AI analysis...',
    knowledgeTitle: '🧠 What AI knows',
    knowledgeSubtitle: 'Based on analyzed documents',
    analyzeBtn: '↻ Analyze',
    knowledgeEmptyHint: 'Upload documents to see what AI understands about this project.',
    knowledgeReadingHint: '✦ AI is reading the documents...',
    analyzeClickHint: 'Click "Analyze" to see what AI has understood.',
    knowledgeScope: 'Scope',
    knowledgeClient: 'Client',
    knowledgeContractor: 'Contractor',
    knowledgeBudget: 'Budget',
    knowledgeDuration: 'Duration',
    knowledgeObjectives: 'Objectives',
    knowledgeConstraints: 'Key Constraints',
    knowledgeTechnical: 'Technical Highlights',
    statsTotalDocs: 'Total documents',
    statsAIAnalysed: 'AI analyzed',
    knowledgeBaseEmpty: 'Knowledge base is empty',
    knowledgeBaseEmptyDesc: 'Upload the contract, technical specifications or any document with project information.',
    filesCount: (n: number) => `${n} file${n === 1 ? '' : 's'}`,
    docAnalysed: '✓ Analyzed',
    docFile: 'File',
    viewDoc: '👁 View',
    viewDocError: 'Could not display the file.',
    savingBtn: 'Saving...',
    savedBtn: '✓ Saved',
    subChapterPlaceholder: 'Subchapter title...',
    categories: [
      { id: 'Σύμβαση', label: 'Contract', icon: '📜', desc: 'Main contract & amendments' },
      { id: 'Τεχνικές Προδιαγραφές', label: 'Technical Specifications', icon: '⚙️', desc: 'Technical documents & specs' },
      { id: 'Μελέτες', label: 'Studies', icon: '🔬', desc: 'Analyses & reports' },
      { id: 'Οικονομικά', label: 'Financials', icon: '💰', desc: 'Budget & financials' },
      { id: 'Άλλα', label: 'Other', icon: '📎', desc: 'Other related documents' },
    ] as { id: string; label: string; icon: string; desc: string }[],
  },
  reporting: {
    title: 'Reports',
    newReport: '+ New Report',
    newReportPlaceholder: 'Report name...',
    create: 'Create',
    noReports: 'No reports yet',
    noReportsHint: 'Create the first report for this project',
    selectReport: 'Select a report from the list',
    addBlock: '+ Add element',
    noBlocks: 'Report is empty',
    noBlocksHint: 'Add elements from the project modules',
    noData: 'No data available',
    deleteReport: 'Delete report',
    deleteReportConfirm: 'Delete report?',
    deleteReportHint: 'This action cannot be undone.',
    renameReport: 'Rename',
    dragHint: 'Drag to reorder',
    sources: {
      Schedule: 'Schedule',
      Budget: 'Budget',
      'Risk Management': 'Risks',
      Issues: 'Issues',
    } as Record<string, string>,
    blocks: {
      schedule_phases: 'Phase Progress',
      schedule_milestones: 'Milestones',
      budget_evm: 'EVM — Performance Indicators',
      budget_client_billing: 'Client Billing',
      budget_vendors: 'Vendors',
      risk_top: 'Top Risks',
      risk_summary: 'Risk Summary',
      issues_open: 'Open Issues',
      issues_critical: 'Critical Issues',
    } as Record<string, string>,
  },
};

export { el, en };
export type ModuleStrings = typeof el;
